// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-25T15:40:20.097Z
// Property: Coral Grove on Grand (ID: 6767906449167723)
// Collections: 42 amenities, 4 floorplans (live), 30 photos, 79 POIs, 4 reviews, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5760613594693632",
  "multihub_property_id": "6767906449167723",
  "property_external_id": "CkBGnr",
  "property_zillow_url": "https://www.zillow.com/apartments/augusta-ga/millhouse-station/CkBGnr/",
  "property_apartments_url": null,
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": null,
  "property_pm_software": null,
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "coral-grove-on-grand",
  "property_name": "Coral Grove on Grand",
  "property_website_url": "https://site-coral-grove-on-grand.pages.dev/",
  "property_domain": null,
  "property_address": "636 11th St",
  "property_full_address": "636 11th St, Augusta, GA 30901",
  "property_address_1": "636 11th St",
  "property_address_2": null,
  "property_address_city": "Augusta",
  "property_address_state": "GA",
  "property_address_zip_full": null,
  "property_address_zip": "30901",
  "property_address_country": "US",
  "property_address_county": "Richmond County",
  "property_neighborhood_address": "Downtown Augusta",
  "property_address_latitude": "33.4718277",
  "property_address_longitude": "-81.97291349999999",
  "property_email": null,
  "property_phone": "5555555555",
  "property_call_tracking_phone": null,
  "property_company_name": "Rebel Residential",
  "property_company_url": null,
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Modern Downtown Augusta apartment living starts here.</strong> Explore one- and two-bedroom homes with quartz countertops, stainless steel appliances, island kitchens, 9-foot ceilings, in-home washer/dryer, and select skyline-view balconies or patios—then schedule your tour of Coral Grove on Grand.</p>",
  "property_long_description": "<p><strong>Modern apartment living with Downtown Augusta at your door.</strong> At Coral Grove on Grand, you can choose a one- or two-bedroom home with polished finishes like quartz countertops, stainless steel appliances, chef-inspired island kitchens, wood-inspired flooring, 9-foot ceilings, walk-in closets, in-home washer/dryer, and select skyline-view balconies or patios.</p><p>Beyond your front door, the community is built for easy, everyday momentum: a retreat-style <a href=\"/amenities\">pool with fire pit</a>, outdoor lounge and gourmet kitchen, Cross-Fit-inspired fitness center with indoor TireFlip, spin room, conference rooms, social hubs, parcel lockers, EV charging, private garages, bike storage, and controlled-access buildings. Pets have thoughtful perks too, including a waterfront off-leash bark park and indoor pet spa.</p><p>Set in <a href=\"/neighborhood\">Downtown Augusta</a>, you’re less than two miles from the Georgia Cyber Center and Medical District, with the Augusta Riverwalk, Broad Street dining, Augusta Canal trails, Savannah River Brewing Co., New Moon Cafe, and SRP Park all close to home.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-227f-730b-917a-fdaa89b29be1.webp",
  "property_featured_image_media": {
    "alt_text": "Community lounge area with a coffee bar and view of the pool and apartment buildings.",
    "public_id": "01a0244b-227f-730b-917a-fdaa89b29be1",
    "storage_key": "property/6767906449167723/01a0244b-227f-730b-917a-fdaa89b29be1.webp",
    "width": 1920,
    "height": 1281
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": null,
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "76",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": null,
  "property_admin_fee": null,
  "property_application_fee": "60",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "15",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Pets are limited by breed; service/assistive animals are exempt.",
  "property_pet_policy_description": "Dogs and cats allowed. One-time pet fee: $300 for the first pet and $150 for the second. Monthly pet rent: $15 per pet. Maximum of 2 pets per apartment. Pets are limited by breed; service/assistive animals are exempt.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": null,
  "property_apply_now_url": null,
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-225a-70fc-bc84-08be1718ecea.webp",
  "property_primary_logo_media": {
    "alt_text": "Coral Grove on Grand logo",
    "public_id": "01a0244b-225a-70fc-bc84-08be1718ecea",
    "storage_key": "property/6767906449167723/01a0244b-225a-70fc-bc84-08be1718ecea.webp",
    "width": 1148,
    "height": 304
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-72c3-72e7-8ced-89fae36cf229.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a0244b-72c3-72e7-8ced-89fae36cf229",
    "storage_key": "property/6767906449167723/01a0244b-72c3-72e7-8ced-89fae36cf229.webp",
    "width": 1148,
    "height": 304
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-66d0-709a-a5ab-5063e794e2f9.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a0244b-66d0-709a-a5ab-5063e794e2f9",
    "storage_key": "property/6767906449167723/01a0244b-66d0-709a-a5ab-5063e794e2f9.webp",
    "width": 1148,
    "height": 304
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5760613594693632/01a03915-19b6-71d4-aeb8-805d7480607e.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#fea981",
  "property_secondary_color": "#3e5b50",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": null,
  "property_bedrooms_min": null,
  "property_bedrooms_max": null,
  "property_bathrooms_range": null,
  "property_bathrooms_min": null,
  "property_bathrooms_max": null,
  "property_sqft_range": null,
  "property_sqft_min": null,
  "property_sqft_max": null,
  "property_price_range": null,
  "property_price_min": null,
  "property_price_max": null,
  "property_available_units": null,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ0woI_GrM-YgRshfYOIdwwvg",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Coral Grove on Grand",
  "property_home_romance_title": "Create Lasting Memories in Your New Apartment Home",
  "property_home_amenities_blurb": "<p><strong>Amenities that keep pace.</strong> Start with concierge coffee, then shift to a conference room, spin studio, or Cross-Fit-inspired training with an indoor TireFlip. Outside, a retreat-style pool, fire pit, gourmet kitchen, nature trails, and a waterfront off-leash bark park bring more range to Downtown Augusta living, while EV charging, garages, parcel lockers, bike storage, and fiber internet keep everyday details easy.</p>",
  "property_home_floorplans_blurb": "<p><strong>Find your fit in Downtown Augusta.</strong> Coral Grove on Grand pairs one- and two-bedroom layouts with open living areas, island kitchens, private bedrooms, and generous storage. Quartz countertops, stainless steel appliances, glass-tile backsplashes, wood-inspired flooring, 9-foot ceilings, and in-home stacked washer/dryers keep each home polished and practical, while select plans add a balcony or patio, walk-in shower, garden tub, sound-reducing windows and doors, or skyline views.</p>",
  "property_home_gallery_blurb": "<p><strong>See Coral Grove on Grand in focus.</strong> Preview quartz island kitchens, stainless steel appliances, wood-inspired flooring, and sunlit spaces with Downtown Augusta views. Then look beyond the apartment to the retreat-style pool, fire pit seating, hammocks, outdoor kitchen, polished lounges, fitness center, and pet-friendly perks like the waterfront bark park and indoor pet spa. Browse the full gallery to picture the details up close.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Riverfront energy, downtown ease.</strong> From Coral Grove on Grand, the Augusta Riverwalk, Broad Street coffee and cocktails, historic theaters, public art, and Augusta Canal trails are all close to home—bringing water views, culture, and everyday stops into one connected neighborhood.</p>",
  "property_home_reviews_blurb": "<p><strong>What stands out in the reviews?</strong> Residents highlight Coral Grove on Grand’s Downtown Augusta convenience, clean modern apartments, well-kept amenities, and responsive service. The pool, resident events, and welcoming atmosphere earn frequent praise, along with the leasing team’s helpful care—especially Sarah and Stephanie, noted for going “above and beyond.” See why one review says it best: “I love it here.”</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the river, then let downtown branch out around you.</strong> Coral Grove on Grand puts you close to the Savannah River rhythm of the Augusta Riverwalk, Broad Street cafés and cocktail spots, and the historic stages of the Miller and Imperial theatres. Pick up coffee at New Moon Cafe, catch the local energy around downtown storefronts and public art, or take the long way home by way of the Augusta Canal National Heritage Area for trail time and water views nearby. Back at home, <a href=\"/amenities\">community comforts</a> like bike storage, outdoor lounges, and pet-friendly spaces help your neighborhood routine feel easy before you head out again.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities with real everyday range.</strong> At Coral Grove on Grand, your routine can move from a concierge coffee stop to focused time in a conference room, a spin session, or a Cross-Fit-inspired workout with an indoor TireFlip—all without leaving the community.</p><p>When it is time to slow down, choose the retreat-style pool and fire pit, outdoor lounges with a gourmet kitchen, or nature trails that add a welcome breath of green to Downtown Augusta living. Pet-friendly perks go beyond the basics with a waterfront off-leash bark park and indoor pet spa, while practical details like EV charging, private garages, bike storage, parcel lockers, climate-controlled storage, valet trash, controlled access, and fiber internet keep the day running smoothly. See more in the <a href=\"/gallery\">photo gallery</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_applynow_blurb": "<p><strong>Your Downtown Augusta home starts here.</strong> Choose a one- or two-bedroom apartment with quartz countertops, stainless steel appliances, 9-foot ceilings, walk-in closets, and in-home washer/dryer. With polished interiors and everyday conveniences in place, Coral Grove on Grand makes it easy to feel ready. Start your online application today.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong><br>Connect with the leasing team at Coral Grove on Grand to learn more about modern one- and two-bedroom apartment living in Downtown Augusta, from polished home finishes to everyday community conveniences.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Coral Grove on Grand?</strong> You’re in the right place. Explore quick answers about leasing, apartment features, community spaces, pet perks, and life in Downtown Augusta. If you need more details or want help finding the right next step, the leasing team is happy to assist.</p>",
  "property_floorplans_blurb": "<p><strong>Start with the layout that fits how you move.</strong> Coral Grove on Grand offers one- and two-bedroom apartment homes in Downtown Augusta, giving you clear choices without the guesswork. Compare open living areas, island kitchens, private bedrooms, generous closet space, and the details that make each plan feel polished from day one.</p><p>Inside, <a href=\"/amenities\">elevated finishes</a> like quartz countertops, stainless steel appliances, glass-tile backsplashes, wood-inspired flooring, 9-foot ceilings, and an in-home stacked washer/dryer bring function and style together. Select layouts add a large balcony or patio, walk-in shower, garden tub, sound-reducing windows and doors, or skyline views. Browse current availability below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which floor plan feels like yours.</p>",
  "property_gallery_blurb": "<p><strong>Let the photos set the tone.</strong> Browse Coral Grove on Grand’s gallery and picture the details up close: bright island kitchens with quartz surfaces and stainless steel appliances, open living spaces with wood-inspired flooring, and large windows or balconies that bring in the Downtown Augusta backdrop.</p><p>Then follow the view outside to the retreat-style pool, fire pit seating, hammocks, landscaped walkways, and outdoor kitchen made for easy evenings close to home. Inside the community, see polished social lounges, conference spaces, a fitness center built for serious movement, and pet-friendly extras from the waterfront bark park to the indoor pet spa. Like what you see? Explore more <a href=\"/amenities\">amenities</a>, take a <a href=\"/virtual-tours\">virtual tour</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the spaces in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore Coral Grove on Grand from every angle.</strong> Use the interactive map to view available one- and two-bedroom apartments, then see how Downtown Augusta puts dining, trails, major employment centers, and everyday destinations close to home.</p>",
  "property_pets_blurb": "<p><strong>For the pets who know the sound of a leash.</strong> At Coral Grove on Grand, daily pet care gets its own set of thoughtful spaces—not just a line in the lease. Head to the waterfront off-leash bark park for open-air play, follow the nature trails for a change of scenery, then make cleanup simple in the indoor pet spa before heading back upstairs.</p><p>Dogs and cats are welcome with the community’s posted pet guidelines, including breed limitations, so you can review the details right here and ask the leasing team any questions. Explore more <a href=\"/amenities\">pet-friendly amenities</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how easy life with your companion can feel in Downtown Augusta.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at Coral Grove on Grand?</strong><br>Share modern Downtown Augusta apartment living with a friend—from quartz countertops and chef-inspired island kitchens to skyline-view balconies, social spaces, pet perks, and everyday conveniences. Invite them to take a closer look and find their next one- or two-bedroom home here.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Coral Grove on Grand.</strong><br>Pay rent, submit maintenance requests, and manage your account in one convenient place—so your day keeps moving in a Downtown Augusta apartment community built for easy, everyday momentum.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real confidence.</strong> As you browse reviews for Coral Grove on Grand, you’ll hear residents point to the details that make daily life easier: a convenient Downtown Augusta location, clean and modern apartments, well-maintained amenities, and a team that responds quickly when questions or service needs come up.</p><p>Residents frequently call out the pool, the overall quality of the property, and the care shown by the leasing office—especially Sarah and Stephanie—for going “above and beyond.” From professional management to resident events and a welcoming atmosphere, the reviews reflect a community people are happy to recommend, with one resident simply saying, “I love it here.”</p>",
  "property_created_at": "1787315266154",
  "property_scheduletour_blurb": "<p><strong>See Coral Grove on Grand in person.</strong> Tour one- and two-bedroom apartments with quartz countertops, stainless steel appliances, island kitchens, 9-foot ceilings, and walk-in closets, then explore community spaces made for everyday ease. Schedule your tour today and get a closer look at modern Downtown Augusta living.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you for reaching out to Coral Grove on Grand.</strong><br>Your inquiry has been received, and the leasing team will be in touch soon. In the meantime, picture modern Downtown Augusta living with quartz countertops, stainless steel appliances, 9-foot ceilings, and inviting community spaces designed for easy everyday momentum.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Coral Grove on Grand",
  "property_seo_title_home": "Coral Grove on Grand |  Apartments in Augusta, GA",
  "property_seo_description_home": "Discover luxury living at Coral Grove on Grand in Augusta, GA. Enjoy stunning floor plans, resort-style amenities, and scenic trails!",
  "property_seo_title_floorplans": "Floor Plans | Augusta, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Coral Grove on Grand in Augusta, GA. Choose from our stylish one and two-bedroom floor plans, tailored to your lifestyle.",
  "property_seo_title_amenities": "Amenities | Augusta, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience resort-style living at Coral Grove on Grand in Augusta, GA. Enjoy luxury amenities like a waterfront bark park, fitness center, and gourmet kitchen!",
  "property_seo_title_gallery": "Gallery | Apartments in Augusta, GA",
  "property_seo_description_gallery": "Experience vibrant living at Coral Grove on Grand! With stunning views, luxury amenities, and inviting designs, picture your perfect home in Augusta, GA.",
  "property_seo_title_virtualtours": "Virtual Tours | Coral Grove on Grand Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Coral Grove on Grand in Augusta, GA! Take a virtual tour of our inviting one and two-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Coral Grove on Grand Apartments",
  "property_seo_description_interactivemap": "Find your perfect oasis at Coral Grove on Grand! Use our interactive map to explore stunning floor plans, community amenities, and secure your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Augusta, GA",
  "property_seo_description_neighborhood": "Uncover the charm of Augusta at Coral Grove on Grand! Experience vibrant local favorites and hidden gems just steps from your new one- or two-bedroom home.",
  "property_seo_title_contact": "Contact Us | Coral Grove on Grand",
  "property_seo_description_contact": "Find your perfect fit at Coral Grove on Grand in Augusta, GA. Our friendly leasing team is here to answer your questions—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Augusta, GA",
  "property_seo_description_faqs": "Find answers to your burning questions about life at Coral Grove on Grand in Augusta, GA! Explore our amenities, floor plans, and community spirit today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Augusta, GA",
  "property_seo_description_reviews": "Join the vibrant community at Coral Grove on Grand! Residents love our waterfront amenities, modern homes, and social events. Hear their stories today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Augusta, GA",
  "property_seo_description_applynow": "Discover luxury living at Coral Grove on Grand in Augusta, GA! Elegant designs, stunning amenities, and a vibrant community await. Secure your spot!",
  "property_seo_title_residentaccess": "Resident Access | Coral Grove on Grand",
  "property_seo_description_residentaccess": "Access Coral Grove on Grand's resident portal for easy rent payments, maintenance requests, and all your community needs—simplifying your life in Augusta, GA!",
  "property_seo_title_referafriend": "Refer A Friend | Coral Grove on Grand",
  "property_seo_description_referafriend": "Refer a friend to Coral Grove on Grand in Augusta, GA! Great friends make unforgettable neighbors. Share the joy of community living today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Coral Grove on Grand",
  "property_seo_description_scheduletour": "Experience vibrant living at Coral Grove on Grand in Augusta, GA. Schedule a tour today and discover your ideal home in a community that truly inspires!",
  "property_seo_title_privacy": "Privacy Policy | Coral Grove on Grand",
  "property_seo_description_privacy": "At Coral Grove on Grand in Augusta, GA, your privacy matters. Uncover how we safeguard your personal information. View our comprehensive privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Coral Grove on Grand",
  "property_seo_description_accessibility": "At Coral Grove on Grand in Augusta, GA, we champion digital inclusion. Discover our commitment to accessibility and enjoy a welcoming community for all.",
  "property_seo_title_sitemap": "Sitemap | Coral Grove on Grand",
  "property_seo_description_sitemap": "Navigate Coral Grove on Grand’s vibrant community in Augusta, GA. Find your perfect apartment with ease—check out our detailed sitemap today!",
  "property_seo_title_thankyou": "Thank You | Coral Grove on Grand",
  "property_seo_description_thankyou": "Thank you for your interest in Coral Grove on Grand in Augusta, GA! Expect a warm welcome from our team soon as we assist you in finding your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Augusta, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787666653539",
  "amenities": [
    {
      "id": "ec_a589e01949674fa4c8179be7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Water Front Off‑Leash Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f5822e126d2f479e6ba84bc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Bike Storage Facility",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae62075c542ba5a6f2d930f0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Gated Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6256a4699c0ed3ac41e841a4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Electric Car Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_00c8a0546e7de2c4829f4890",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Private Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3418c4965404ce2bd8b74ee1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Indoor Pet Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_776c1a9f29ab99ee70f008f8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Retreat Inspired Pool Area With Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3226e280100bc0073ad18ce4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Outdoor Lounge Areas and Gourmet Style Kitchen",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7edcabbc6d3ac4e8102d8701",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Nature Trails",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cfa81fb767abf059c344993e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Mail Room Complete with Parcel Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_87b0deda54e0de00cbe8825a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Monthly Social Events",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1bbb997a9e5c2dafeea7601",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Air‑Conditioned Corridors",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c5e965725d016eea4cdcad0b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Complimentary Concierge Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35a004401f7925eccd78b153",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_420f576b043871ec6d378541",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Indoor Lounge with Private Spaces Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_db54d1e5fb3202889a626169",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Conference Rooms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b9cc2b5f116ede42b37d5b9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Social Hubs",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47223689a84320556ef2cd1c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Cross‑Fit Inspired Fitness Center Complete With Indoor TireFlip",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cc0da074e90e1bb549c63d8e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Spin Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_589f9be445c5f5b032b1d4ec",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Door‑to‑Door Valet Trash Service",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02c00ef809b5f8aa5a963e29",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Controlled Access Buildings",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e426a64b518066b1887ca6d1",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Climate‑Controlled Storage Units",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1b4439c12dd863cc50e4df8",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Online Maintenance Request and Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e6779334eb71b787a30e13e2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Less than 2 miles from the Cyber Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a6182b336bd946b1e65efe0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Less than 2 miles from Medical District",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5149f577ec5b4044c8044d7e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Quartz Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ac77257305888bb3fa45020",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8e5a34f6d4cc3c7d4a8ab12e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Chef Inspired Island Kitchens",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5be41aac994ad15af700762d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Built‑In Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fc7bc1e80da3b49b8c7fbf4c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Glass Tiled Backsplash",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_22aa2fc82acf81a0d7506699",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Wood Inspired Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9c56114170fa432d5c988654",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "9' Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37b7fd40ff5305cd6cec932a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑In Shower*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ad67549c11a3520eb31f066",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Oversize Garden Tubs*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3e2ed57bf8de4da75e158008",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Walk‑In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e294e0fe88fa25e092216ca9",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Impact Rated And Sound Reducing Windows And Doors*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f477a395c976e3a032f20803",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Stacked Washer/Dryer in each home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4957acf8269a4509efeec53e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Elevator Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8f87e36898212e49cc0d977e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Downtown Skyline Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3b8aeaa7356e9f68a9cc389c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Large Balcony/Patio",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_067b61113876de45bd8c6097",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2f705cb74d2f1d7630d361a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "external_id": "false",
      "title": "Fiber Internet provided by WC Fiber",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_e48f4cc7-4125-4d11-be91-794d89ccf050",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-eb45-718a-b9a5-7f782f5ed644.webp",
      "image_media": {
        "alt_text": "Aerial view of a modern apartment complex with a large, illuminated swimming pool and lounge chairs at dusk.",
        "public_id": "01a0244c-eb45-718a-b9a5-7f782f5ed644",
        "storage_key": "property/6767906449167723/01a0244c-eb45-718a-b9a5-7f782f5ed644.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Experience luxury living with our resort-style swimming pool and ample lounging space. Enjoy the vibrant community atmosphere day or night.",
      "link": "",
      "alt_text": "Aerial view of a modern apartment complex with a large, illuminated swimming pool and lounge chairs at dusk.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0e0915d9-7922-44f2-99f2-fb15ed5cc658",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-e133-70b5-8ffe-71e31f0d296b.webp",
      "image_media": {
        "alt_text": "Electric vehicle charging stations with parking spots in front of a building.",
        "public_id": "01a0244c-e133-70b5-8ffe-71e31f0d296b",
        "storage_key": "property/6767906449167723/01a0244c-e133-70b5-8ffe-71e31f0d296b.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Convenient electric vehicle charging stations available for residents, located in designated parking spots.",
      "link": "",
      "alt_text": "Electric vehicle charging stations with parking spots in front of a building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6a7cc5e-2dbd-4896-b17f-fc87c1c67d8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-e0be-7008-bed8-f040ef011d64.webp",
      "image_media": {
        "alt_text": "Fenced-in dog park with gravel ground, benches, and a fire hydrant.",
        "public_id": "01a0244c-e0be-7008-bed8-f040ef011d64",
        "storage_key": "property/6767906449167723/01a0244c-e0be-7008-bed8-f040ef011d64.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, a safe and clean space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Fenced-in dog park with gravel ground, benches, and a fire hydrant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a7a087c2-a04f-4609-a251-5232366dc458",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-e172-72fc-a327-8cd95f51619e.webp",
      "image_media": {
        "alt_text": "Mailroom with mailboxes and package lockers.",
        "public_id": "01a0244c-e172-72fc-a327-8cd95f51619e",
        "storage_key": "property/6767906449167723/01a0244c-e172-72fc-a327-8cd95f51619e.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Secure and convenient mailroom with individual mailboxes and smart package lockers for residents.",
      "link": "",
      "alt_text": "Mailroom with mailboxes and package lockers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_dd133311-8df8-4d07-bfe8-5381b8662bed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-e090-7552-8fba-92f94e10be1f.webp",
      "image_media": {
        "alt_text": "Elevator lobby with two elevators and an exit door leading to a parking lot.",
        "public_id": "01a0244c-e090-7552-8fba-92f94e10be1f",
        "storage_key": "property/6767906449167723/01a0244c-e090-7552-8fba-92f94e10be1f.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Modern elevator lobby featuring two sleek elevators and a well-lit exit leading to the property's parking area.",
      "link": "",
      "alt_text": "Elevator lobby with two elevators and an exit door leading to a parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_21e14b6a-7b6f-4aeb-962d-38007d30121d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-d39f-71d7-aea0-d357d08a0a95.webp",
      "image_media": {
        "alt_text": "Modern fitness center with treadmills, ellipticals, rowing machine, free weights, and a tire for functional training.",
        "public_id": "01a0244c-d39f-71d7-aea0-d357d08a0a95",
        "storage_key": "property/6767906449167723/01a0244c-d39f-71d7-aea0-d357d08a0a95.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Stay active and energized in our state-of-the-art fitness center, fully equipped with cardio machines, weight training equipment, and functional training tools.",
      "link": "",
      "alt_text": "Modern fitness center with treadmills, ellipticals, rowing machine, free weights, and a tire for functional training.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1ee08a30-3cda-42d0-a905-a7d91616f110",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-d69a-7179-b4d1-7eed5dc52201.webp",
      "image_media": {
        "alt_text": "Pet spa with a stainless steel washing station, sink, and drying area.",
        "public_id": "01a0244c-d69a-7179-b4d1-7eed5dc52201",
        "storage_key": "property/6767906449167723/01a0244c-d69a-7179-b4d1-7eed5dc52201.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Pamper your pets at our convenient on-site pet spa, featuring a wash station and drying area.",
      "link": "",
      "alt_text": "Pet spa with a stainless steel washing station, sink, and drying area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0f4bb4d7-9082-48a6-8dc3-a750f5633364",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-d5dd-731e-b0b4-37dee0537657.webp",
      "image_media": {
        "alt_text": "Fitness center with punching bag, medicine balls, weights, and TRX straps.",
        "public_id": "01a0244c-d5dd-731e-b0b4-37dee0537657",
        "storage_key": "property/6767906449167723/01a0244c-d5dd-731e-b0b4-37dee0537657.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of equipment for all your workout needs, including cardio machines, free weights, and functional training gear.",
      "link": "",
      "alt_text": "Fitness center with punching bag, medicine balls, weights, and TRX straps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96536e3c-fc32-4d2c-a95a-680280134b9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-c996-70ca-b26e-0623a542c426.webp",
      "image_media": {
        "alt_text": "Interior seating area with a large window overlooking the community pool and outdoor seating.",
        "public_id": "01a0244c-c996-70ca-b26e-0623a542c426",
        "storage_key": "property/6767906449167723/01a0244c-c996-70ca-b26e-0623a542c426.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish seating area, featuring comfortable furniture and expansive views of the community pool and outdoor amenities.",
      "link": "",
      "alt_text": "Interior seating area with a large window overlooking the community pool and outdoor seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a54e499-c152-4e0e-8466-a6752853c6d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-be7e-71ac-b1c3-d66faf684af1.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a modern apartment building.",
        "public_id": "01a0244c-be7e-71ac-b1c3-d66faf684af1",
        "storage_key": "property/6767906449167723/01a0244c-be7e-71ac-b1c3-d66faf684af1.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor pool, complete with comfortable lounge chairs and umbrellas for ultimate relaxation. Perfect for sunny afternoons.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, adjacent to a modern apartment building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94efd11d-f355-491c-9e62-671c7c7dd442",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-b6fc-770f-a8d9-c7cdd9867967.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs, hammocks, and a city skyline view.",
        "public_id": "01a0244c-b6fc-770f-a8d9-c7cdd9867967",
        "storage_key": "property/6767906449167723/01a0244c-b6fc-770f-a8d9-c7cdd9867967.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Community",
      "description": "Relax by our sparkling swimming pool, complete with comfortable lounge chairs and serene hammocks. Enjoy the city views from this oasis.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs, hammocks, and a city skyline view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a6ada404-2dea-4841-9d25-55abcd098bf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-b624-7279-a7b8-8ebbe76644e1.webp",
      "image_media": {
        "alt_text": "Stacked Whirlpool washer and dryer in a laundry closet.",
        "public_id": "01a0244c-b624-7279-a7b8-8ebbe76644e1",
        "storage_key": "property/6767906449167723/01a0244c-b624-7279-a7b8-8ebbe76644e1.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Apartment",
      "description": "Convenient in-unit stacked Whirlpool washer and dryer.",
      "link": "",
      "alt_text": "Stacked Whirlpool washer and dryer in a laundry closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_341acdd2-2d3f-4059-8356-e857dc82fc64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-b5a0-75ba-9b86-30fd13516dd1.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving.",
        "public_id": "01a0244c-b5a0-75ba-9b86-30fd13516dd1",
        "storage_key": "property/6767906449167723/01a0244c-b5a0-75ba-9b86-30fd13516dd1.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample wire shelving, ready for your storage needs.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_82a7e29c-b416-4379-b73b-be277a054b6f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-b4ef-72b6-9a92-e6f86b70ca8b.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with a sink.",
        "public_id": "01a0244c-b4ef-72b6-9a92-e6f86b70ca8b",
        "storage_key": "property/6767906449167723/01a0244c-b4ef-72b6-9a92-e6f86b70ca8b.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this modern apartment bathroom, featuring a sleek vanity with a sink, a bathtub and shower combo, and a convenient toilet.",
      "link": "",
      "alt_text": "Modern bathroom with a bathtub, shower, toilet, and vanity with a sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_37fa7b26-9ddf-4dae-9daf-497124ac6ed9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-abbc-706a-9ec8-8352d51a3a4a.webp",
      "image_media": {
        "alt_text": "Empty apartment room with a balcony door and window overlooking a pool and building.",
        "public_id": "01a0244c-abbc-706a-9ec8-8352d51a3a4a",
        "storage_key": "property/6767906449167723/01a0244c-abbc-706a-9ec8-8352d51a3a4a.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Apartment",
      "description": "View from an empty apartment room with a balcony door open to a view of the pool and surrounding buildings.",
      "link": "",
      "alt_text": "Empty apartment room with a balcony door and window overlooking a pool and building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_01c8ca66-6ebd-45fc-96a9-835508cd9117",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-a2cf-724e-a8c9-2863722bb4bf.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
        "public_id": "01a0244c-a2cf-724e-a8c9-2863722bb4bf",
        "storage_key": "property/6767906449167723/01a0244c-a2cf-724e-a8c9-2863722bb4bf.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Apartment",
      "description": "A sleek and modern kitchen featuring stainless steel appliances, ample cabinet space, and a bright, inviting atmosphere.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and light wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9fcf9ef-640d-43ff-ac1d-781203b1af0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-a1e7-733f-a6b5-a8a8278defc2.webp",
      "image_media": {
        "alt_text": "Kitchen island with pendant lights and dark doors.",
        "public_id": "01a0244c-a1e7-733f-a6b5-a8a8278defc2",
        "storage_key": "property/6767906449167723/01a0244c-a1e7-733f-a6b5-a8a8278defc2.webp",
        "width": 1136,
        "height": 757
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring a spacious island with pendant lighting, ample cabinet space, and a view to the living area and balcony.",
      "link": "",
      "alt_text": "Kitchen island with pendant lights and dark doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_70c21d6f-758e-431b-bade-64173041e1f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-010e-7538-8726-10398484028f.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white tub, shower, toilet, and vanity with sink.",
        "public_id": "01a0244c-010e-7538-8726-10398484028f",
        "storage_key": "property/6767906449167723/01a0244c-010e-7538-8726-10398484028f.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "This contemporary bathroom features a sleek vanity with a single basin sink, a clean white tub and shower combo, and a toilet. A spacious walk-in closet is visible through the open doorway.",
      "link": "",
      "alt_text": "Modern bathroom with white tub, shower, toilet, and vanity with sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1c4cc36-49a2-4603-b552-4239fe58d203",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-ff12-77a6-a7bb-95ecb6695da6.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with built-in grills and bar seating, adjacent to a pool area.",
        "public_id": "01a0244b-ff12-77a6-a7bb-95ecb6695da6",
        "storage_key": "property/6767906449167723/01a0244b-ff12-77a6-a7bb-95ecb6695da6.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Community",
      "description": "Enjoy convenient outdoor grilling with our top-of-the-line built-in grills and spacious bar seating, perfect for entertaining guests by the pool.",
      "link": "",
      "alt_text": "Outdoor grilling station with built-in grills and bar seating, adjacent to a pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fe4d916c-4dc6-42d6-863f-3540bca715d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-ff0e-7086-8bb8-384c13b86983.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with a modern cinder block fireplace and seating, overlooking a pool and bar area.",
        "public_id": "01a0244b-ff0e-7086-8bb8-384c13b86983",
        "storage_key": "property/6767906449167723/01a0244b-ff0e-7086-8bb8-384c13b86983.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Community",
      "description": "Relax and unwind on the spacious outdoor patio, complete with a stylish cinder block fireplace and comfortable seating. Enjoy the convenience of an adjacent bar and pool area.",
      "link": "",
      "alt_text": "Outdoor patio area with a modern cinder block fireplace and seating, overlooking a pool and bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f9b3c5e1-170b-4b89-81c4-98ecc85445aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-010d-737e-9462-7c26b3e8d36a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and stainless steel appliances",
        "public_id": "01a0244c-010d-737e-9462-7c26b3e8d36a",
        "storage_key": "property/6767906449167723/01a0244c-010d-737e-9462-7c26b3e8d36a.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring an island, stainless steel appliances, and ample cabinet space, perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with island and stainless steel appliances",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aaa17e52-4275-4807-b6dd-85b5beed33e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-fecd-72ca-919d-4dd4d66f767f.webp",
      "image_media": {
        "alt_text": "Stylish community lounge area with a bar, seating, and dining table.",
        "public_id": "01a0244b-fecd-72ca-919d-4dd4d66f767f",
        "storage_key": "property/6767906449167723/01a0244b-fecd-72ca-919d-4dd4d66f767f.webp",
        "width": 1000,
        "height": 667
      },
      "title": "Community",
      "description": "Enjoy our modern community lounge, perfect for socializing or relaxing. Features a fully equipped bar area and a spacious dining table.",
      "link": "",
      "alt_text": "Stylish community lounge area with a bar, seating, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e6a3b77b-2861-4fb5-94f0-052636a78979",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-32d5-764b-ac28-46147a8cd0f0.webp",
      "image_media": {
        "alt_text": "Pet spa grooming station with stainless steel tub and ramp",
        "public_id": "01a0244b-32d5-764b-ac28-46147a8cd0f0",
        "storage_key": "property/6767906449167723/01a0244b-32d5-764b-ac28-46147a8cd0f0.webp",
        "width": 1920,
        "height": 1871
      },
      "title": "Community",
      "description": "Groom your furry friends at our convenient on-site pet spa, complete with a professional grooming tub and sink. Making pet care easy and accessible for our residents.",
      "link": "",
      "alt_text": "Pet spa grooming station with stainless steel tub and ramp",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5125af02-6d16-4af7-b686-2e16c7aef9ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-3afd-73b4-b359-b14e9018c334.webp",
      "image_media": {
        "alt_text": "Luxury bathroom with a large soaking tub, double vanity with granite countertops, and a glass-enclosed shower.",
        "public_id": "01a0244b-3afd-73b4-b359-b14e9018c334",
        "storage_key": "property/6767906449167723/01a0244b-3afd-73b4-b359-b14e9018c334.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Experience ultimate relaxation in this spacious bathroom, featuring a deep soaking tub, elegant double vanity, and a modern glass shower.",
      "link": "",
      "alt_text": "Luxury bathroom with a large soaking tub, double vanity with granite countertops, and a glass-enclosed shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_259efb93-21a8-4520-9214-1d59ca704855",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-37d1-702a-aca8-f73995a401d4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
        "public_id": "01a0244b-37d1-702a-aca8-f73995a401d4",
        "storage_key": "property/6767906449167723/01a0244b-37d1-702a-aca8-f73995a401d4.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Apartment",
      "description": "Gourmet kitchen featuring white shaker cabinets, stainless steel appliances including a refrigerator, microwave, and oven, and a spacious island with bar seating.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and a large island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1eb37f0-f207-4e35-86e5-c61e7f65bc0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-3323-729a-95c7-626a9c7800ff.webp",
      "image_media": {
        "alt_text": "Grilling burgers and hot dogs on a barbecue.",
        "public_id": "01a0244b-3323-729a-95c7-626a9c7800ff",
        "storage_key": "property/6767906449167723/01a0244b-3323-729a-95c7-626a9c7800ff.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a summer cookout with friends and family at our community's barbecue grills.",
      "link": "",
      "alt_text": "Grilling burgers and hot dogs on a barbecue.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac8e8d1f-82a8-4ee5-8d5a-9658ebedc473",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-28a0-727a-b936-28b37e94ff25.webp",
      "image_media": {
        "alt_text": "Weight room with dumbbells, weight machines, and benches.",
        "public_id": "01a0244b-28a0-727a-b936-28b37e94ff25",
        "storage_key": "property/6767906449167723/01a0244b-28a0-727a-b936-28b37e94ff25.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "State-of-the-art fitness center with a wide selection of weights and machines for a complete workout.",
      "link": "",
      "alt_text": "Weight room with dumbbells, weight machines, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4f40d41a-90b1-42f1-8641-f4749a26120b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-227f-730b-917a-fdaa89b29be1.webp",
      "image_media": {
        "alt_text": "Community lounge area with a coffee bar and view of the pool and apartment buildings.",
        "public_id": "01a0244b-227f-730b-917a-fdaa89b29be1",
        "storage_key": "property/6767906449167723/01a0244b-227f-730b-917a-fdaa89b29be1.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy a fresh cup of coffee in our community lounge, featuring a modern coffee bar and comfortable seating. Step outside to relax by the sparkling pool or take in the views of our beautiful apartment homes.",
      "link": "",
      "alt_text": "Community lounge area with a coffee bar and view of the pool and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3f9360d4-9719-4631-8a3b-3fb3fe8069cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-2272-7692-bfd7-933e4be1410f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and modern apartment buildings in the background.",
        "public_id": "01a0244b-2272-7692-bfd7-933e4be1410f",
        "storage_key": "property/6767906449167723/01a0244b-2272-7692-bfd7-933e4be1410f.webp",
        "width": 1728,
        "height": 1152
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge seating and elegant apartment buildings.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and modern apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bfd69ae0-255b-44e8-962f-f080f0c32fd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244b-2273-740c-9266-487aa0bab5c9.webp",
      "image_media": {
        "alt_text": "Modern lounge area with pool table, fireplace, and outdoor pool view.",
        "public_id": "01a0244b-2273-740c-9266-487aa0bab5c9",
        "storage_key": "property/6767906449167723/01a0244b-2273-740c-9266-487aa0bab5c9.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Enjoy leisure time in our stylish resident lounge featuring a billiards table, cozy seating, and a view of the resort-style pool.",
      "link": "",
      "alt_text": "Modern lounge area with pool table, fireplace, and outdoor pool view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_5d7cb3375b09433adfe9f5bb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Commander Coffee",
      "poi_type": "Restaurants",
      "poi_address": "1128 Jones St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-3a8b-71ce-ba6d-6a6a8c7c72ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-3a8b-71ce-ba6d-6a6a8c7c72ea",
        "storage_key": "property/6767906449167723/01a0244c-3a8b-71ce-ba6d-6a6a8c7c72ea.webp",
        "width": 724,
        "height": 1086
      },
      "poi_business_url": "http://commandercoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4674151579583577176&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "commander-coffee",
      "poi_latitude": "33.4782524",
      "poi_longitude": "-81.9719619",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-432-8571",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFRAx0LLN-YgRWPxozxjs3UA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_roastery"
    },
    {
      "id": "ec_8ef762a55ae1503ceca48807",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "New Moon Cafe",
      "poi_type": "Restaurants",
      "poi_address": "JB White's Building storefront, 936 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Upbeat cafe offering freshly roasted coffee beans & a menu of housemade pastries, soups & entrees.",
      "poi_long_description": "Upbeat cafe offering freshly roasted coffee beans & a menu of housemade pastries, soups & entrees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-38f5-7199-82ee-155745f12162.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-38f5-7199-82ee-155745f12162",
        "storage_key": "property/6767906449167723/01a0244c-38f5-7199-82ee-155745f12162.webp",
        "width": 736,
        "height": 751
      },
      "poi_business_url": "http://www.newmoondowntown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2836655769248368860&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-moon-cafe",
      "poi_latitude": "33.4761248",
      "poi_longitude": "-81.9686866",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-823-2008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9b00-7396-b9fb-ee589d97bf64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244c-9b00-7396-b9fb-ee589d97bf64",
        "storage_key": "property/6767906449167723/01a0244c-9b00-7396-b9fb-ee589d97bf64.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJvQqUNWnM-YgR3IgclGTTXSc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_c6fcc99e25b979fa711a00a0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Emil's",
      "poi_type": "Restaurants",
      "poi_address": "902 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-39b5-7502-b3b8-5d3d1a5a5fee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-39b5-7502-b3b8-5d3d1a5a5fee",
        "storage_key": "property/6767906449167723/01a0244c-39b5-7502-b3b8-5d3d1a5a5fee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://emilskitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4503228073093606619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "emils",
      "poi_latitude": "33.4757812",
      "poi_longitude": "-81.967717",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-503-7912",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a7-776f-b17d-72cc8e847adc",
        "storage_key": "property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzZ8vCcTN-YgR26xPxxKufj4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_d4a9b767c2dfb3fdf8f99558",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Laziza Mediterranean Grill - Augusta",
      "poi_type": "Restaurants",
      "poi_address": "901 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Casual, fast-casual Mediterranean restaurant serving fresh salads, kebabs, wraps, and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-5067-71bc-97b5-1cfd6816896a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-5067-71bc-97b5-1cfd6816896a",
        "storage_key": "property/6767906449167723/01a0244c-5067-71bc-97b5-1cfd6816896a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lazizagrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3979530657474791703&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "laziza-mediterranean-grill---augusta",
      "poi_latitude": "33.4762446",
      "poi_longitude": "-81.9674775",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-814-7710",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a7-776f-b17d-72cc8e847adc",
        "storage_key": "property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQcwDOgfN-YgRF8mPawwiOjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "ec_96caa43261f21507c88f4ef0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "TACOCAT AUGUSTA, GA",
      "poi_type": "Restaurants",
      "poi_address": "208 10th St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-39b6-776c-9668-e4257ce7596e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-39b6-776c-9668-e4257ce7596e",
        "storage_key": "property/6767906449167723/01a0244c-39b6-776c-9668-e4257ce7596e.webp",
        "width": 400,
        "height": 500
      },
      "poi_business_url": "https://tacocataugusta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9765897727485569133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tacocat-augusta-ga",
      "poi_latitude": "33.4760957",
      "poi_longitude": "-81.9698763",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-842-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a7-776f-b17d-72cc8e847adc",
        "storage_key": "property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgWNnrfzN-YgRbWiSvz1wh4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "taco_restaurant"
    },
    {
      "id": "ec_3a29459a95021037d3c71a18",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Pho-Ramen'L",
      "poi_type": "Restaurants",
      "poi_address": "990 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-3c8f-7500-b3a5-de468bed3933.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-3c8f-7500-b3a5-de468bed3933",
        "storage_key": "property/6767906449167723/01a0244c-3c8f-7500-b3a5-de468bed3933.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://phoramenl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7375404314255494508&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-ramenl",
      "poi_latitude": "33.4763813",
      "poi_longitude": "-81.96969589999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-842-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a7-776f-b17d-72cc8e847adc",
        "storage_key": "property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc7WLd93N-YgRbA0VsiWzWmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_038b5f6d510c3e6ecb62bc93",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Stillwater Taproom",
      "poi_type": "Restaurants",
      "poi_address": "974 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Pool and dart pub with live music and relaxed vibes, plus outdoor seating.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-3df7-76bf-945e-b0e52e0236b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-3df7-76bf-945e-b0e52e0236b4",
        "storage_key": "property/6767906449167723/01a0244c-3df7-76bf-945e-b0e52e0236b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/StillwaterTaproomAugusta/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14999420273488822749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stillwater-taproom",
      "poi_latitude": "33.4762764",
      "poi_longitude": "-81.96931459999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-826-9857",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9af6-7434-9947-2e33ab6d51c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244c-9af6-7434-9947-2e33ab6d51c8",
        "storage_key": "property/6767906449167723/01a0244c-9af6-7434-9947-2e33ab6d51c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX_rqyW7M-YgR3QEYtkSlKNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "ec_6359d326dee1999d0184d302",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Savannah River Brewing Co.",
      "poi_type": "Restaurants",
      "poi_address": "813 5th St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-3812-70a2-9a79-8d45be72464e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-3812-70a2-9a79-8d45be72464e",
        "storage_key": "property/6767906449167723/01a0244c-3812-70a2-9a79-8d45be72464e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.savannahriverbrew.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6086813936799175872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "savannah-river-brewing-co",
      "poi_latitude": "33.4647089",
      "poi_longitude": "-81.963646",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-426-8212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqdKMkg3M-YgRwNTPtAa1eFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewery"
    },
    {
      "id": "ec_6cafb1ca0837451ad456d23b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Lenox on Tenth",
      "poi_type": "Restaurants",
      "poi_address": "211 10th St, Augusta, GA 30901, USA",
      "poi_short_description": "Vibrant eatery serving Southern staples like grits, burgers and tacos, along with cocktails and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-3d42-7265-be3f-9a2c69e4826a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-3d42-7265-be3f-9a2c69e4826a",
        "storage_key": "property/6767906449167723/01a0244c-3d42-7265-be3f-9a2c69e4826a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lenox-on-tenth.ueniweb.com/?utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11631784611204207490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenox-on-tenth",
      "poi_latitude": "33.476064",
      "poi_longitude": "-81.9701652",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-426-8322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a7-776f-b17d-72cc8e847adc",
        "storage_key": "property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJs1vgtADN-YgRgpOu3nlmbKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_f2aef8da34f34c0b9d0dea0c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Nacho Mama's",
      "poi_type": "Restaurants",
      "poi_address": "976 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Burritos headline this funky storefront eatery also serving nachos, tacos & festive margaritas.",
      "poi_long_description": "Burritos headline this funky storefront eatery also serving nachos, tacos & festive margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-393e-7458-9e16-ca57e0945e55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-393e-7458-9e16-ca57e0945e55",
        "storage_key": "property/6767906449167723/01a0244c-393e-7458-9e16-ca57e0945e55.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.nachomamasaugusta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17901787952727292051&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nacho-mamas",
      "poi_latitude": "33.4762036",
      "poi_longitude": "-81.9694188",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-724-0501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a7-776f-b17d-72cc8e847adc",
        "storage_key": "property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-yjPyW7M-YgRk3itlkvtb_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "ec_6621799cb02a22ffeaf66642",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Luigi's - Augusta, GA",
      "poi_type": "Restaurants",
      "poi_address": "590 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Family-run since 1949, this warm eatery offers a Greek-Italian menu, old-world charm & a jukebox.",
      "poi_long_description": "Family-run since 1949, this warm eatery offers a Greek-Italian menu, old-world charm & a jukebox.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-40c4-753f-bc5e-eeeb0be3c736.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-40c4-753f-bc5e-eeeb0be3c736",
        "storage_key": "property/6767906449167723/01a0244c-40c4-753f-bc5e-eeeb0be3c736.webp",
        "width": 613,
        "height": 514
      },
      "poi_business_url": "http://www.luigisinc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2776500958512649670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "luigis---augusta-ga",
      "poi_latitude": "33.473471",
      "poi_longitude": "-81.961553",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-722-4056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a7-776f-b17d-72cc8e847adc",
        "storage_key": "property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIUBS0nPM-YgRxpWtRukciCY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "ec_653fbb64299c356ca0667b33",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Sole Augusta",
      "poi_type": "Restaurants",
      "poi_address": "1033 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Modern dining space offering eclectic small bites, burgers & sushi in a festive vibe, plus a patio.",
      "poi_long_description": "Modern dining space offering eclectic small bites, burgers & sushi in a festive vibe, plus a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-3ecc-704b-af8b-5753a9951a68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-3ecc-704b-af8b-5753a9951a68",
        "storage_key": "property/6767906449167723/01a0244c-3ecc-704b-af8b-5753a9951a68.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://soleaugusta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14562709902438865762&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sole-augusta",
      "poi_latitude": "33.4773968",
      "poi_longitude": "-81.9704891",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-432-9898",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a7-776f-b17d-72cc8e847adc",
        "storage_key": "property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2egKGnM-YgRYpvu7X8jGco",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_103dc3b081f441249e3fba36",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "The Boll Weevil Cafe and Sweetery",
      "poi_type": "Restaurants",
      "poi_address": "10 James Brown Blvd, Augusta, GA 30901, USA",
      "poi_short_description": "Southern specialties, sandwiches, soup & wine served in a former cotton warehouse.",
      "poi_long_description": "Southern specialties, sandwiches, soup & wine served in a former cotton warehouse.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-40b7-71b8-8e66-48cc04916e3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-40b7-71b8-8e66-48cc04916e3e",
        "storage_key": "property/6767906449167723/01a0244c-40b7-71b8-8e66-48cc04916e3e.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://thebollweevil.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17865375501196589420&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boll-weevil-cafe-and-sweetery",
      "poi_latitude": "33.4780899",
      "poi_longitude": "-81.96618269999999",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-722-7772",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a7-776f-b17d-72cc8e847adc",
        "storage_key": "property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJNWDTu2_M-YgRbPnJD12Q7vc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_655bdba49283ad0e913e3378",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Craft & Vine",
      "poi_type": "Restaurants",
      "poi_address": "1204 Broad St B, Augusta, GA 30901, USA",
      "poi_short_description": "Choice venue serving New American fare & cocktails in warm digs with a modern speakeasy feel.",
      "poi_long_description": "Choice venue serving New American fare & cocktails in warm digs with a modern speakeasy feel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-4255-773c-aea5-2e3fb53f98fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-4255-773c-aea5-2e3fb53f98fa",
        "storage_key": "property/6767906449167723/01a0244c-4255-773c-aea5-2e3fb53f98fa.webp",
        "width": 600,
        "height": 450
      },
      "poi_business_url": "https://craftandvine.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16703684222495614716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "craft--vine",
      "poi_latitude": "33.4776138",
      "poi_longitude": "-81.9729996",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-496-8442",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9af6-7434-9947-2e33ab6d51c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244c-9af6-7434-9947-2e33ab6d51c8",
        "storage_key": "property/6767906449167723/01a0244c-9af6-7434-9947-2e33ab6d51c8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHc0irGnM-YgR_OYl6kxoz-c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cocktail_bar"
    },
    {
      "id": "ec_87f361839aa468b8e75dfa90",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Frog Hollow Tavern",
      "poi_type": "Restaurants",
      "poi_address": "1282 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "A seasonally-driven menu of New American fare (and 100+ wines) are served in this modern space.",
      "poi_long_description": "A seasonally-driven menu of New American fare (and 100+ wines) are served in this modern space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-450b-7009-8adb-bf15bc58e372.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-450b-7009-8adb-bf15bc58e372",
        "storage_key": "property/6767906449167723/01a0244c-450b-7009-8adb-bf15bc58e372.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://froghollowtavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2361850762763642121&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frog-hollow-tavern",
      "poi_latitude": "33.4782152",
      "poi_longitude": "-81.9748769",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-364-6906",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a7-776f-b17d-72cc8e847adc",
        "storage_key": "property/6767906449167723/01a0244a-e8a7-776f-b17d-72cc8e847adc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMT_dLmjM-YgRCSUDT8H6xiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_ffb6fcd29b8bfce542d35d59",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "The Earth Pantry",
      "poi_type": "Shopping & Retail",
      "poi_address": "1026 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Eco-conscious retailer selling earth-friendly groceries as well as household and personal care items.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-4afd-71ef-8783-ebeb329876da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-4afd-71ef-8783-ebeb329876da",
        "storage_key": "property/6767906449167723/01a0244c-4afd-71ef-8783-ebeb329876da.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://theearthpantry.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1412490903368084201&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-earth-pantry",
      "poi_latitude": "33.47664",
      "poi_longitude": "-81.97049539999999",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 678-735-9535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a5-73d7-8211-d1d37ae1710a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a5-73d7-8211-d1d37ae1710a",
        "storage_key": "property/6767906449167723/01a0244a-e8a5-73d7-8211-d1d37ae1710a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRXM6oX_f-YgR6aq5L_4smhM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_00abcd289a85c409970c881b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "CK Gas & Food Mart",
      "poi_type": "Transportation & Transit",
      "poi_address": "2852 Deans Bridge Rd STE. A, Augusta, GA 30906, USA",
      "poi_short_description": "Gas station with a restroom offering ethanol-free gas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-4568-7729-b972-7a600b9b3fe8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-4568-7729-b972-7a600b9b3fe8",
        "storage_key": "property/6767906449167723/01a0244c-4568-7729-b972-7a600b9b3fe8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10100358140653565012&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ck-gas--food-mart",
      "poi_latitude": "33.4329368",
      "poi_longitude": "-82.0354663",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 706-869-3222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9af4-76e4-bb2a-0cd359c78de3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244c-9af4-76e4-bb2a-0cd359c78de3",
        "storage_key": "property/6767906449167723/01a0244c-9af4-76e4-bb2a-0cd359c78de3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJr0uUyR7O-YgRVHThBTeuK4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "ec_5b48f173ee1566d29698fae7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Coliseum Lotto",
      "poi_type": "Shopping & Retail",
      "poi_address": "808 11th St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-475d-7416-ba24-bf0c368faa7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-475d-7416-ba24-bf0c368faa7a",
        "storage_key": "property/6767906449167723/01a0244c-475d-7416-ba24-bf0c368faa7a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4897304571820401956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coliseum-lotto",
      "poi_latitude": "33.4692944",
      "poi_longitude": "-81.97472259999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 762-994-1885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e88f-73aa-83d4-25c4d2880a12",
        "storage_key": "property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEz9DUhXM-YgRJGVAoI-49kM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "ec_001b245d9dc714130ea889e3",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Circle K",
      "poi_type": "Shopping & Retail",
      "poi_address": "902 Walton Wy, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-47c7-70ab-8b95-250d52adb56d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-47c7-70ab-8b95-250d52adb56d",
        "storage_key": "property/6767906449167723/01a0244c-47c7-70ab-8b95-250d52adb56d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.circlek.com/store-locator?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=5531033403702822924&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "circle-k",
      "poi_latitude": "33.4687666",
      "poi_longitude": "-81.9716564",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-724-6020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9afe-7259-aba7-0a89ee2a5e64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244c-9afe-7259-aba7-0a89ee2a5e64",
        "storage_key": "property/6767906449167723/01a0244c-9afe-7259-aba7-0a89ee2a5e64.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJbT13yhTM-YgRDMiGdJMtwkw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_6e5e9c635321fe986cbe2446",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "843 Laney Walker Blvd, Augusta, GA 30901, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-488c-75a7-9e3c-4da56c0e9764.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-488c-75a7-9e3c-4da56c0e9764",
        "storage_key": "property/6767906449167723/01a0244c-488c-75a7-9e3c-4da56c0e9764.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://locations.dollartree.com/ga/augusta/843-laney-walker-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=10065977456023875315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "33.4640467",
      "poi_longitude": "-81.9728947",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-303-3240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e88f-73aa-83d4-25c4d2880a12",
        "storage_key": "property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDwME1hXM-YgR865kFyqJsYs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_23b59ba5e70245b315c5b6a0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "825 Laney Walker Blvd, Augusta, GA 30901, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-488c-75a7-9e3c-48a651b07bac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-488c-75a7-9e3c-48a651b07bac",
        "storage_key": "property/6767906449167723/01a0244c-488c-75a7-9e3c-48a651b07bac.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://locations.familydollar.com/ga/augusta/825-laney-walker-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=924593520752442440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "33.4638785",
      "poi_longitude": "-81.9722294",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 762-233-0706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e88f-73aa-83d4-25c4d2880a12",
        "storage_key": "property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBbZDfBbM-YgRSLwTjujQ1Aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "ec_83d9b0079091e875a3fdc2fe",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta & Co.",
      "poi_type": "Shopping & Retail",
      "poi_address": "1010 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Friendly outlet selling locally made items, from art to stickers and tees.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-4e83-727d-805e-b5573a12fd34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-4e83-727d-805e-b5573a12fd34",
        "storage_key": "property/6767906449167723/01a0244c-4e83-727d-805e-b5573a12fd34.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.augustaandcompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8288566665406160986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta--co",
      "poi_latitude": "33.4764582",
      "poi_longitude": "-81.9702078",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-724-4067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGSfYTq_N-YgRWqCtrHfnBnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_information_center"
    },
    {
      "id": "ec_cc986091efd90f5b147adcbb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Candle Company",
      "poi_type": "Shopping & Retail",
      "poi_address": "1124 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Candle store featuring bath products and candle-making workshops for all ages.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-5378-73d0-8941-8fbb6a26079b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-5378-73d0-8941-8fbb6a26079b",
        "storage_key": "property/6767906449167723/01a0244c-5378-73d0-8941-8fbb6a26079b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.augustacandlecompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2070977918858676868&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-candle-company",
      "poi_latitude": "33.4770858",
      "poi_longitude": "-81.9718839",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-364-2402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e88f-73aa-83d4-25c4d2880a12",
        "storage_key": "property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2Va3MsPN-YgRhMo_13GXvRw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "ec_327bc6bc7fdff80109690ec0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Locally Grown",
      "poi_type": "Shopping & Retail",
      "poi_address": "631 Chafee Ave Suite 102, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-5643-718b-971c-cff39f07e3f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-5643-718b-971c-cff39f07e3f5",
        "storage_key": "property/6767906449167723/01a0244c-5643-718b-971c-cff39f07e3f5.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://augustalocallygrown.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8895480479554633047&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-locally-grown",
      "poi_latitude": "33.476872",
      "poi_longitude": "-81.989351",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 706-701-2834",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJU0ufFmPN-YgRV31Gql0Yc3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "ec_58c610b5db61c68f69713208",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Olde Town",
      "poi_type": "Shopping & Retail",
      "poi_address": "443 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-55d3-7689-a321-8a4859fd2878.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-55d3-7689-a321-8a4859fd2878",
        "storage_key": "property/6767906449167723/01a0244c-55d3-7689-a321-8a4859fd2878.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=11983256818185056806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olde-town",
      "poi_latitude": "33.4728932",
      "poi_longitude": "-81.95784499999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-294-9551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9afe-7259-aba7-0a89ee2a5e64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244c-9afe-7259-aba7-0a89ee2a5e64",
        "storage_key": "property/6767906449167723/01a0244c-9afe-7259-aba7-0a89ee2a5e64.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJv34XEXTM-YgRJrIyDJYUTaY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_fe1623bddaa01f14d480afaa",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "John S. Davidson Fine Arts Magnet School",
      "poi_type": "Education",
      "poi_address": "615 12th St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-4ff5-742c-9b30-34c311704824.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-4ff5-742c-9b30-34c311704824",
        "storage_key": "property/6767906449167723/01a0244c-4ff5-742c-9b30-34c311704824.webp",
        "width": 1280,
        "height": 756
      },
      "poi_business_url": "http://davidson.rcboe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8010355608443158689&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "john-s-davidson-fine-arts-magnet-school",
      "poi_latitude": "33.4740924",
      "poi_longitude": "-81.9756403",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-823-6924",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJWyz9c2rM-YgRoQDQNfx_Km8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_21f8712d97666af93f568575",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Paine College",
      "poi_type": "Education",
      "poi_address": "1235 15th St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-50af-75bc-90e1-850122406202.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-50af-75bc-90e1-850122406202",
        "storage_key": "property/6767906449167723/01a0244c-50af-75bc-90e1-850122406202.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.paine.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8027819516029114679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paine-college",
      "poi_latitude": "33.4695551",
      "poi_longitude": "-81.9932536",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 706-821-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJo7O2azXM-YgRNxndDVGLaG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_19d60504e7f4e047286011fb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "A. R. Johnson Health Science and Engineering Magnet School",
      "poi_type": "Education",
      "poi_address": "1324 Laney Walker Blvd #2726, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-5513-7519-a18a-02eca41b3a28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-5513-7519-a18a-02eca41b3a28",
        "storage_key": "property/6767906449167723/01a0244c-5513-7519-a18a-02eca41b3a28.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://arjohnson.rcboe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8453264680865980449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-r-johnson-health-science-and-engineering-magnet-school",
      "poi_latitude": "33.4653987",
      "poi_longitude": "-81.9810937",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-823-6933",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJC9wdIznM-YgRIWBfn3AHUHU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_1b8452a3d25062be879f4c27",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "T. W. Josey",
      "poi_type": "Education",
      "poi_address": "1701 15th St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-54f9-709e-8cde-85946644958e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-54f9-709e-8cde-85946644958e",
        "storage_key": "property/6767906449167723/01a0244c-54f9-709e-8cde-85946644958e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://josey.rcboe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16399103997907054627&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-w-josey",
      "poi_latitude": "33.4551714",
      "poi_longitude": "-82.00051820000002",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 706-737-7360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjeEO6dPN-YgRIzDwLTNSleM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_ebda2e1c3e4321f34fe308b7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Lucy Craft Laney High School",
      "poi_type": "Education",
      "poi_address": "1339 Laney Walker Blvd, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-5af4-7716-bd8c-85b3132e88cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-5af4-7716-bd8c-85b3132e88cc",
        "storage_key": "property/6767906449167723/01a0244c-5af4-7716-bd8c-85b3132e88cc.webp",
        "width": 1280,
        "height": 713
      },
      "poi_business_url": "http://laney.rcboe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1276999698898494882&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucy-craft-laney-high-school",
      "poi_latitude": "33.4669181",
      "poi_longitude": "-81.9821707",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-823-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcVu6HDnM-YgRoiUg13XQuBE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_23a99872b2ab45d37cdcd499",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Academy of Richmond County",
      "poi_type": "Education",
      "poi_address": "910 Russell St, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-5e20-76bf-b0b2-060e67202e9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-5e20-76bf-b0b2-060e67202e9e",
        "storage_key": "property/6767906449167723/01a0244c-5e20-76bf-b0b2-060e67202e9e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://arc.rcboe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16444604748872264672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "academy-of-richmond-county",
      "poi_latitude": "33.4738113",
      "poi_longitude": "-82.005436",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 706-737-7152",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV3fEB7fN-YgR4Ks7UOT4NuQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_4048b026803ddea8e9a64575",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta University",
      "poi_type": "Education",
      "poi_address": "1120 15th St, Augusta, GA 30912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-b9a9-752b-aea0-81ca07338e08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-b9a9-752b-aea0-81ca07338e08",
        "storage_key": "property/6767906449167723/01a0244a-b9a9-752b-aea0-81ca07338e08.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.augusta.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16052566819240658722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-university",
      "poi_latitude": "33.4709094",
      "poi_longitude": "-81.9898848",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 706-721-4191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdYZ_m8rN-YgRIscP0ngsxt4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_b84214da204622928e631c15",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Heritage Academy",
      "poi_type": "Education",
      "poi_address": "333 Greene St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-5c12-705a-bb0c-07b8ed7138fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-5c12-705a-bb0c-07b8ed7138fd",
        "storage_key": "property/6767906449167723/01a0244c-5c12-705a-bb0c-07b8ed7138fd.webp",
        "width": 614,
        "height": 346
      },
      "poi_business_url": "http://www.heritageacademyaugusta.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11908860117240231722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "heritage-academy",
      "poi_latitude": "33.47012110000001",
      "poi_longitude": "-81.9559874",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-821-0034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN9tCG3XM-YgRKrfrRy7FRKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_8d7f556667ffcb3e347d68b2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Family YMCA Child Development Academy",
      "poi_type": "Education",
      "poi_address": "1425 Walton Wy, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-6274-71ee-996f-9406c8a85618.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-6274-71ee-996f-9406c8a85618",
        "storage_key": "property/6767906449167723/01a0244c-6274-71ee-996f-9406c8a85618.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://thefamilyy.org/branch/child-development-academy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1880129346919787998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-ymca-child-development-academy",
      "poi_latitude": "33.4741755",
      "poi_longitude": "-81.9828885",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-922-9670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ25vhkUbM-YgR3u3w_q2PFxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_a56d1bfb5043370eec55318e",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Clarian Place Childcare and Learning Center",
      "poi_type": "Education",
      "poi_address": "1209 Augusta Ave #3201, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-5ede-769b-9905-c6243b5afd40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-5ede-769b-9905-c6243b5afd40",
        "storage_key": "property/6767906449167723/01a0244c-5ede-769b-9905-c6243b5afd40.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.clarianplacechildcare.com/augusta",
      "poi_directions_map_url": "https://maps.google.com/?cid=11335656048672096884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarian-place-childcare-and-learning-center",
      "poi_latitude": "33.46745780000001",
      "poi_longitude": "-81.98580539999999",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-869-2421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-ae2OevN-YgRdMIbDR5XUJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "ec_2dc40bf88e31666d5e39800a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Imperial Theatre",
      "poi_type": "Entertainment",
      "poi_address": "749 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Built in 1918, this elegant theater hosts ballets, musicals, music & movies throughout the year.",
      "poi_long_description": "Built in 1918, this elegant theater hosts ballets, musicals, music & movies throughout the year.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-5e5f-71ce-b508-4ed80beefc62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-5e5f-71ce-b508-4ed80beefc62",
        "storage_key": "property/6767906449167723/01a0244c-5e5f-71ce-b508-4ed80beefc62.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.imperialtheatre.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14152884368723943432&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "imperial-theatre",
      "poi_latitude": "33.4752371",
      "poi_longitude": "-81.9646235",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-722-8341",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1z1HG7M-YgRCCD4IFklacQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "ec_d344018309177a4aeb536290",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Miller Theater",
      "poi_type": "Entertainment",
      "poi_address": "708 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "Genteel, refurbished art deco performing arts center hosting concerts & theatrical performances.",
      "poi_long_description": "Genteel, refurbished art deco performing arts center hosting concerts & theatrical performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-6320-70ed-b7ba-a8c0a403b07b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-6320-70ed-b7ba-a8c0a403b07b",
        "storage_key": "property/6767906449167723/01a0244c-6320-70ed-b7ba-a8c0a403b07b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.millertheateraugusta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=140900348206196521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "miller-theater",
      "poi_latitude": "33.4744873",
      "poi_longitude": "-81.9639969",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-842-4080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKS96-HHM-YgRKSePwx6U9AE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_55a80a5f907b009b96258771",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Morris Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "1 10th St 2nd floor, Augusta, GA 30901, USA",
      "poi_short_description": "Paintings, sculpture & photography are shown off at this museum focused on Southern art.",
      "poi_long_description": "Paintings, sculpture & photography are shown off at this museum focused on Southern art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-c5e9-71d4-ab87-1e7bcb125deb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-c5e9-71d4-ab87-1e7bcb125deb",
        "storage_key": "property/6767906449167723/01a0244a-c5e9-71d4-ab87-1e7bcb125deb.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.themorris.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8931158464085768884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "morris-museum-of-art",
      "poi_latitude": "33.4794199",
      "poi_longitude": "-81.968522",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-724-7501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8ba-70d4-b082-a9948c9cf57f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8ba-70d4-b082-a9948c9cf57f",
        "storage_key": "property/6767906449167723/01a0244a-e8ba-70d4-b082-a9948c9cf57f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJjSVeRG_M-YgRtDqOxE3Z8Xs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "ec_f5752f3a937cf548950bbd32",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Museum of History",
      "poi_type": "Entertainment",
      "poi_address": "560 Reynolds St, Augusta, GA 30901, USA",
      "poi_short_description": "Museum devoted to Augusta's heritage & culture, from Native American settlement to James Brown.",
      "poi_long_description": "Museum devoted to Augusta's heritage & culture, from Native American settlement to James Brown.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-c191-76ff-ac0b-672f792fe640.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-c191-76ff-ac0b-672f792fe640",
        "storage_key": "property/6767906449167723/01a0244a-c191-76ff-ac0b-672f792fe640.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.augustamuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041842750651209303&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-museum-of-history",
      "poi_latitude": "33.4747658",
      "poi_longitude": "-81.960556",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 706-722-8454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8ba-70d4-b082-a9948c9cf57f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8ba-70d4-b082-a9948c9cf57f",
        "storage_key": "property/6767906449167723/01a0244a-e8ba-70d4-b082-a9948c9cf57f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGzr4Y3HM-YgRV5YFVmSAYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "ec_435b9422e2f09c52b0d669bb",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Canal Discovery Center",
      "poi_type": "Entertainment",
      "poi_address": "Blome Ln, Augusta, GA 30901, USA",
      "poi_short_description": "Walkable museum featuring interactive displays, plus boat tours of the Augusta Canal.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-649a-730e-8354-85e231e9698a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-649a-730e-8354-85e231e9698a",
        "storage_key": "property/6767906449167723/01a0244c-649a-730e-8354-85e231e9698a.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://augustacanal.com/about-discovery-center.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=16298820688099662440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-canal-discovery-center",
      "poi_latitude": "33.4780991",
      "poi_longitude": "-81.9825393",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-823-0440",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8ba-70d4-b082-a9948c9cf57f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8ba-70d4-b082-a9948c9cf57f",
        "storage_key": "property/6767906449167723/01a0244a-e8ba-70d4-b082-a9948c9cf57f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJDQqyrGDN-YgRaNr3mw8LMeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_91edf9a514a2cf9b0a12e855",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Le Chat Noir",
      "poi_type": "Entertainment",
      "poi_address": "304 8th St, Augusta, GA 30901, USA",
      "poi_short_description": "100-seat performing arts space, cocktail lounge & cabaret hosts local troupes & film screenings.",
      "poi_long_description": "100-seat performing arts space, cocktail lounge & cabaret hosts local troupes & film screenings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-66fa-735c-856a-e3b650386a9c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-66fa-735c-856a-e3b650386a9c",
        "storage_key": "property/6767906449167723/01a0244c-66fa-735c-856a-e3b650386a9c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lcnaugusta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16064930215871240870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "le-chat-noir",
      "poi_latitude": "33.4740672",
      "poi_longitude": "-81.965762",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-842-8001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUTT3W3M-YgRptpxauoY8t4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_8313c3554a12c8199f60d5de",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Sacred Heart Cultural Center",
      "poi_type": "Entertainment",
      "poi_address": "1301 Greene St, Augusta, GA 30901, USA",
      "poi_short_description": "Cultural center hosting concerts & art exhibits in a former 19th-century Catholic church.",
      "poi_long_description": "Cultural center hosting concerts & art exhibits in a former 19th-century Catholic church.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-62be-7379-a52a-3a5935aa55d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-62be-7379-a52a-3a5935aa55d6",
        "storage_key": "property/6767906449167723/01a0244c-62be-7379-a52a-3a5935aa55d6.webp",
        "width": 720,
        "height": 900
      },
      "poi_business_url": "http://www.sacredheartaugusta.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15176422055973097119&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sacred-heart-cultural-center",
      "poi_latitude": "33.4773862",
      "poi_longitude": "-81.9764422",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-826-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj8-HXULM-YgRnw6up3N7ndI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cultural_center"
    },
    {
      "id": "ec_92061ca5026190052427cc15",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "The Boyhood Home of President Woodrow Wilson",
      "poi_type": "Entertainment",
      "poi_address": "419 7th St, Augusta, GA 30901, USA",
      "poi_short_description": "Exhibits on President Wilson are on display at this 1859 manse & guided tours are offered some days.",
      "poi_long_description": "Exhibits on President Wilson are on display at this 1859 manse & guided tours are offered some days.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-67b9-74da-a07d-226319818046.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-67b9-74da-a07d-226319818046",
        "storage_key": "property/6767906449167723/01a0244c-67b9-74da-a07d-226319818046.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.wilsonboyhoodhome.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14349798624160632062&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-boyhood-home-of-president-woodrow-wilson",
      "poi_latitude": "33.4716991",
      "poi_longitude": "-81.9650119",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-722-9828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9af9-707e-a201-3848a2541b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244c-9af9-707e-a201-3848a2541b3b",
        "storage_key": "property/6767906449167723/01a0244c-9af9-707e-a201-3848a2541b3b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr5Q1nW3M-YgR_sx799G5JMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "ec_ec668fee4fc4f830aacb60b7",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Gertrude Herbert Institute of Art",
      "poi_type": "Education",
      "poi_address": "506 Telfair St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-6a8c-73bd-9993-d10905612df2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-6a8c-73bd-9993-d10905612df2",
        "storage_key": "property/6767906449167723/01a0244c-6a8c-73bd-9993-d10905612df2.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.ghia.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6356146933098625182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gertrude-herbert-institute-of-art",
      "poi_latitude": "33.4696696",
      "poi_longitude": "-81.96098309999999",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-722-5495",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD5tvPXPM-YgRnjiIl_WRNVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_e1daa31dc194942262684104",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Lucy Craft Laney Museum",
      "poi_type": "Entertainment",
      "poi_address": "1116 Phillips St, Augusta, GA 30901, USA",
      "poi_short_description": "Small house showcasing the legacy of a prominent African-American educator through history & art.",
      "poi_long_description": "Small house showcasing the legacy of a prominent African-American educator through history & art.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-6c20-757e-b69a-80944fc1a5b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-6c20-757e-b69a-80944fc1a5b6",
        "storage_key": "property/6767906449167723/01a0244c-6c20-757e-b69a-80944fc1a5b6.webp",
        "width": 1280,
        "height": 1063
      },
      "poi_business_url": "http://lucycraftlaneymuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11677543028182352345&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucy-craft-laney-museum",
      "poi_latitude": "33.4671149",
      "poi_longitude": "-81.981248",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-724-3576",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8ba-70d4-b082-a9948c9cf57f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8ba-70d4-b082-a9948c9cf57f",
        "storage_key": "property/6767906449167723/01a0244a-e8ba-70d4-b082-a9948c9cf57f.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJr2PNKTnM-YgR2QEmjIP3DqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "ec_acfa2e116bad8f98b560d09a",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Piedmont Augusta",
      "poi_type": "Health and Wellness",
      "poi_address": "1350 Walton Wy, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-d248-7189-917d-91cc34b15d8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-d248-7189-917d-91cc34b15d8c",
        "storage_key": "property/6767906449167723/01a0244a-d248-7189-917d-91cc34b15d8c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-augusta?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MzU5NDYwNzQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1886772285160638636&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-augusta",
      "poi_latitude": "33.4707366",
      "poi_longitude": "-81.9827533",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 706-722-9011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-0eaee9826250.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-0eaee9826250",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-0eaee9826250.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJW5AIREfM-YgRrEgNlWUpLxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_b52b86fc10eb12d69c61f4c4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Wellstar MCG Health Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1120 15th St, Augusta, GA 30912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-cec4-768c-860d-0238cea84138.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-cec4-768c-860d-0238cea84138",
        "storage_key": "property/6767906449167723/01a0244a-cec4-768c-860d-0238cea84138.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wellstar.org/locations/hospital/mcg-health-medical-center?utm_medium=listing&utm_source=google&utm_content=Wellstar_MCG_Health_Medical_Center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17915315532089959605&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wellstar-mcg-health-medical-center",
      "poi_latitude": "33.4713125",
      "poi_longitude": "-81.9878626",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-721-0211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-0eaee9826250.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-0eaee9826250",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-0eaee9826250.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyX-W70nM-YgRtaRCmY78n_g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "ec_731a851cb92fab65f21bf29d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Charlie Norwood VA Medical Center - Downtown Division",
      "poi_type": "Health and Wellness",
      "poi_address": "950 15th St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-6ece-7654-b123-21c01df2ac10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-6ece-7654-b123-21c01df2ac10",
        "storage_key": "property/6767906449167723/01a0244c-6ece-7654-b123-21c01df2ac10.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.augusta.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1155020191173974679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlie-norwood-va-medical-center---downtown-division",
      "poi_latitude": "33.4727166",
      "poi_longitude": "-81.9889262",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 706-733-0188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-0eaee9826250.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-0eaee9826250",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-0eaee9826250.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJU4Z5vUnM-YgRlxpUi750BxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_0533e06af558faeea52702e2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "MedNow Urgent Care - Walton Way",
      "poi_type": "Health and Wellness",
      "poi_address": "2030 Walton Wy, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-71f8-7358-aea6-ce864b9873e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-71f8-7358-aea6-ce864b9873e2",
        "storage_key": "property/6767906449167723/01a0244c-71f8-7358-aea6-ce864b9873e2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.mednowurgentcare.net/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13102812520614130384&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mednow-urgent-care---walton-way",
      "poi_latitude": "33.4754093",
      "poi_longitude": "-82.0060268",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 706-955-7527",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJixWzGbfN-YgR0PK-2ZCK1rU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "ec_dbcedc81d9ade3f8b61e58ce",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1520 Walton Wy, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-6e07-72ee-bed5-4e34b1fe6906.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-6e07-72ee-bed5-4e34b1fe6906",
        "storage_key": "property/6767906449167723/01a0244c-6e07-72ee-bed5-4e34b1fe6906.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/augusta-ga-pharmacies/1520-walton-way-augusta-ga-30904/storeid=3378?WT.mc_id=LS_GOOGLE_RX_3378",
      "poi_directions_map_url": "https://maps.google.com/?cid=3263623327505403650&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "33.475087",
      "poi_longitude": "-81.9889749",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-724-0598",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9b12-7629-b390-a4328b54ef06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244c-9b12-7629-b390-a4328b54ef06",
        "storage_key": "property/6767906449167723/01a0244c-9b12-7629-b390-a4328b54ef06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-W5CJ0nM-YgRAk-j_B-4Si0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_64f5059cf1f3a631d33e2a6b",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Walgreens Specialty Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1022 Walton Wy Ste C, Augusta, GA 30901, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-7379-7383-acd3-79f2f158f631.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-7379-7383-acd3-79f2f158f631",
        "storage_key": "property/6767906449167723/01a0244c-7379-7383-acd3-79f2f158f631.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-1022+walton+way-augusta-ga-30901/id=21163",
      "poi_directions_map_url": "https://maps.google.com/?cid=17181232356055934843&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-specialty-pharmacy",
      "poi_latitude": "33.4697463",
      "poi_longitude": "-81.9741574",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 706-619-2467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9b12-7629-b390-a4328b54ef06.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244c-9b12-7629-b390-a4328b54ef06",
        "storage_key": "property/6767906449167723/01a0244c-9b12-7629-b390-a4328b54ef06.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_amtEfN-YgRe2cpOsz_b-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_52584bca43c3142f3bc85e7d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "The Salvation Army Kroc Center Augusta",
      "poi_type": "Entertainment",
      "poi_address": "1833 Broad St, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-76ac-72aa-8d12-99c30df6a5e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-76ac-72aa-8d12-99c30df6a5e7",
        "storage_key": "property/6767906449167723/01a0244c-76ac-72aa-8d12-99c30df6a5e7.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://augustakroc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17154006658372188463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-salvation-army-kroc-center-augusta",
      "poi_latitude": "33.4852529",
      "poi_longitude": "-81.9952162",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-364-5762",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhW6YqlPM-YgRL7n1gitGD-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "ec_565605052ed7306c9dcffce4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Oxygen Fitness Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "357 Highland Ave, Augusta, GA 30909, USA",
      "poi_short_description": "Friendly, welcoming fitness studio offering an array of classes (pilates, yoga, barre, spin and more) in a clean space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-76fc-74c8-a79e-e34d19f55c04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-76fc-74c8-a79e-e34d19f55c04",
        "storage_key": "property/6767906449167723/01a0244c-76fc-74c8-a79e-e34d19f55c04.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.oxygenfitstudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7661073728112844963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oxygen-fitness-studio",
      "poi_latitude": "33.4871044",
      "poi_longitude": "-82.0305293",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 706-364-7746",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGxD5UoXN-YgRo2A-MveZUWo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_34b13847b490775763c1b3f4",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Space Yoga + Wellness Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "1502 Monte Sano Ave, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-7843-77ba-a601-716bcca3ee8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-7843-77ba-a601-716bcca3ee8a",
        "storage_key": "property/6767906449167723/01a0244c-7843-77ba-a601-716bcca3ee8a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.spaceyogastudio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5614905189872433863&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "space-yoga--wellness-studio",
      "poi_latitude": "33.4706933",
      "poi_longitude": "-82.02790420000001",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-447-9857",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1PWM-3N-YgRx_rXaYUm7E0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wellness_center"
    },
    {
      "id": "ec_f39fa2049fe5532ef9349032",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Riverwalk Augusta",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10th St, Augusta, GA 30901, USA",
      "poi_short_description": "Riverfront park with brick walking paths, plus a splash fountain, playground & nearby amenities.",
      "poi_long_description": "Riverfront park with brick walking paths, plus a splash fountain, playground & nearby amenities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-d324-7588-89ee-247136b4f29f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-d324-7588-89ee-247136b4f29f",
        "storage_key": "property/6767906449167723/01a0244a-d324-7588-89ee-247136b4f29f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.visitaugusta.com/things-to-do/attractions/riverwalk/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13844092904120241189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverwalk-augusta",
      "poi_latitude": "33.4796956",
      "poi_longitude": "-81.9679085",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-821-1754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ebcd-72cc-ae4c-24c1fae203b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ebcd-72cc-ae4c-24c1fae203b4",
        "storage_key": "property/6767906449167723/01a0244a-ebcd-72cc-ae4c-24c1fae203b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSSYD32_M-YgRJcyXqyUZIMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_2682a6da1a4bfc254750d0f0",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Common",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "836 Reynolds St, Augusta, GA 30901, USA",
      "poi_short_description": "Picnicking, festivals, and other events are held at this green space with a public restroom.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-7b59-756a-9529-9a058a1a7ac5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-7b59-756a-9529-9a058a1a7ac5",
        "storage_key": "property/6767906449167723/01a0244c-7b59-756a-9529-9a058a1a7ac5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.augustaga.gov/2769/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=609356393169457237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-common",
      "poi_latitude": "33.476352",
      "poi_longitude": "-81.965974",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-821-1754",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ebcd-72cc-ae4c-24c1fae203b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ebcd-72cc-ae4c-24c1fae203b4",
        "storage_key": "property/6767906449167723/01a0244a-ebcd-72cc-ae4c-24c1fae203b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJseXpRm7M-YgRVZB6PGnedAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_3c832a423eacda03f23976cc",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Springfield Village Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1211 Jones St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-7b59-756a-9529-9fdaadb3f0f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-7b59-756a-9529-9fdaadb3f0f2",
        "storage_key": "property/6767906449167723/01a0244c-7b59-756a-9529-9fdaadb3f0f2.webp",
        "width": 1280,
        "height": 1033
      },
      "poi_business_url": "https://www.exploregeorgia.org/augusta/outdoors-nature/parks/springfield-village-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18030842783802344494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "springfield-village-park",
      "poi_latitude": "33.478887",
      "poi_longitude": "-81.972725",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ebcd-72cc-ae4c-24c1fae203b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ebcd-72cc-ae4c-24c1fae203b4",
        "storage_key": "property/6767906449167723/01a0244a-ebcd-72cc-ae4c-24c1fae203b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJdaOv6hPN-YgRLkR0-fprOvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c5a5b69b9ebc0c3145b88d34",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Boathouse Community Center",
      "poi_type": "Entertainment",
      "poi_address": "101 Riverfront Dr, Augusta, GA 30901, USA",
      "poi_short_description": "Spacious venue for weddings and other events, plus scenic riverside picnic grounds.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-7950-773d-b86e-d254604788d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-7950-773d-b86e-d254604788d0",
        "storage_key": "property/6767906449167723/01a0244c-7950-773d-b86e-d254604788d0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=305187141479933150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boathouse-community-center",
      "poi_latitude": "33.4693912",
      "poi_longitude": "-81.9437209",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 706-821-2870",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmWKKRNrL-YgR3qTtlRY-PAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "ec_9db46e174a551225494bf12c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Riverwalk Marina",
      "poi_type": "Entertainment",
      "poi_address": "1 5th St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-7d49-73ca-8591-f11435074f51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-7d49-73ca-8591-f11435074f51",
        "storage_key": "property/6767906449167723/01a0244c-7d49-73ca-8591-f11435074f51.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6063053200563516385&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-riverwalk-marina",
      "poi_latitude": "33.4765833",
      "poi_longitude": "-81.95996389999999",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 706-869-5404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV-I4v3bM-YgR4TPiMcNKJFQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "marina"
    },
    {
      "id": "ec_989fdc85af92923db9e555f2",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Lake Olmsted Park Disc Golf Course",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2230 Broad St, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-8200-7377-b744-1d9cf2cc714c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-8200-7377-b744-1d9cf2cc714c",
        "storage_key": "property/6767906449167723/01a0244c-8200-7377-b744-1d9cf2cc714c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=10412146329632589451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-olmsted-park-disc-golf-course",
      "poi_latitude": "33.4898644",
      "poi_longitude": "-82.0066446",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS0AFkzLN-YgRi0Yjv-tff5A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "athletic_field"
    },
    {
      "id": "ec_7dcd283743d658b2245d4d36",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Phinizy Swamp Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1858 Lock and Dam Rd, Augusta, GA 30906, USA",
      "poi_short_description": "Forest & swampland featuring multiuse trails, plus a science facility offering classes & events.",
      "poi_long_description": "Forest & swampland featuring multiuse trails, plus a science facility offering classes & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-d4af-77ac-bb9b-9a269df885b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-d4af-77ac-bb9b-9a269df885b2",
        "storage_key": "property/6767906449167723/01a0244a-d4af-77ac-bb9b-9a269df885b2.webp",
        "width": 1280,
        "height": 731
      },
      "poi_business_url": "http://phinizycenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4753505645186806179&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phinizy-swamp-nature-park",
      "poi_latitude": "33.3846224",
      "poi_longitude": "-81.96751119999999",
      "poi_miles_from_property": "7.2 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-828-2109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ebcd-72cc-ae4c-24c1fae203b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ebcd-72cc-ae4c-24c1fae203b4",
        "storage_key": "property/6767906449167723/01a0244a-ebcd-72cc-ae4c-24c1fae203b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJzyqD3dfO-YgRo3Es-zLY90E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ebafd3767b294eabd4a98397",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "May Park Community Center",
      "poi_type": "Entertainment",
      "poi_address": "622 4th St, Augusta, GA 30901, USA",
      "poi_short_description": "Community center with a basketball gym, fitness center, and picnic area, plus recreational programs.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9466-70ef-b347-1aa3d8d82d94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-9466-70ef-b347-1aa3d8d82d94",
        "storage_key": "property/6767906449167723/01a0244c-9466-70ef-b347-1aa3d8d82d94.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.augustaga.gov/facilities/facility/details/May-Park-92",
      "poi_directions_map_url": "https://maps.google.com/?cid=16503944387366813072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "may-park-community-center",
      "poi_latitude": "33.4652712",
      "poi_longitude": "-81.9590219",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-724-0504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFe_onQvM-YgRkP3MifrJCeU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "ec_a769a1364c23199e0b364549",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "New Savannah Bluff Lock & Dam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2105 Lock and Dam Rd, Augusta, GA 30906, USA",
      "poi_short_description": "Public green space by the dam offering picnic areas, restrooms, fishing spots & a boat ramp.",
      "poi_long_description": "Public green space by the dam offering picnic areas, restrooms, fishing spots & a boat ramp.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-818e-70a2-a8af-38276540568c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-818e-70a2-a8af-38276540568c",
        "storage_key": "property/6767906449167723/01a0244c-818e-70a2-a8af-38276540568c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.augustaga.gov/2769/Parks-Recreation",
      "poi_directions_map_url": "https://maps.google.com/?cid=15987135064465371239&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-savannah-bluff-lock--dam-park",
      "poi_latitude": "33.3736464",
      "poi_longitude": "-81.9459801",
      "poi_miles_from_property": "9.0 mi",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 706-793-9403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ebcd-72cc-ae4c-24c1fae203b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ebcd-72cc-ae4c-24c1fae203b4",
        "storage_key": "property/6767906449167723/01a0244a-ebcd-72cc-ae4c-24c1fae203b4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJozorjEvP-YgRZ3CmPaO23d0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_c8600827200b008489844b70",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Transit–Broad Street Transfer Facility",
      "poi_type": "Transportation & Transit",
      "poi_address": "1546 Broad St, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-818d-72cb-bad6-282ce96600a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-818d-72cb-bad6-282ce96600a4",
        "storage_key": "property/6767906449167723/01a0244c-818d-72cb-bad6-282ce96600a4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.augustaga.gov/262/Routes",
      "poi_directions_map_url": "https://maps.google.com/?cid=5813114795642107948&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-transitbroad-street-transfer-facility",
      "poi_latitude": "33.4811726",
      "poi_longitude": "-81.9850068",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 706-821-1719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvQJENUXM-YgRLLjQgBtVrFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_df55f2b787cbf921fadb3c09",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "1546 Broad St, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-80ee-70ad-af83-ba8b47961abc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-80ee-70ad-af83-ba8b47961abc",
        "storage_key": "property/6767906449167723/01a0244c-80ee-70ad-af83-ba8b47961abc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/augusta-ga/augusta-public-transit?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=4416824392841289290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "33.4811726",
      "poi_longitude": "-81.9850068",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi2D2jmnM-YgRSt6VSmK2Sz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_c963980d6345e2f5f45bcf52",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Transit Maintenance Facility",
      "poi_type": "Transportation & Transit",
      "poi_address": "2844 Regency Blvd, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13435308580866252082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-transit-maintenance-facility",
      "poi_latitude": "33.4421424",
      "poi_longitude": "-82.03680410000001",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiRBo4frP-YgRMl1KkvjNc7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "ec_837458d5e12ff8dcf845f873",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "2844 Regency Blvd, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-86f9-77ba-b93a-c9ac0baeae74.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-86f9-77ba-b93a-c9ac0baeae74",
        "storage_key": "property/6767906449167723/01a0244c-86f9-77ba-b93a-c9ac0baeae74.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.augustaga.gov/2770/Transit",
      "poi_directions_map_url": "https://maps.google.com/?cid=12295790834085506330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-transit",
      "poi_latitude": "33.4421844",
      "poi_longitude": "-82.03680410000001",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 706-821-1721",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ec5e-7418-9f35-baeb0327fe71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ec5e-7418-9f35-baeb0327fe71",
        "storage_key": "property/6767906449167723/01a0244a-ec5e-7418-9f35-baeb0327fe71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC7dBLE_M-YgRGq0rIp5so6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_1a56cf5af2bac4d5f27d2f1c",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Daniel Field Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1775 Highland Ave, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-d9ca-743b-b784-a3417a376197.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-d9ca-743b-b784-a3417a376197",
        "storage_key": "property/6767906449167723/01a0244a-d9ca-743b-b784-a3417a376197.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.augustaaviation.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12821155787908389856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daniel-field-airport",
      "poi_latitude": "33.4661169",
      "poi_longitude": "-82.0353969",
      "poi_miles_from_property": "3.9 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 706-733-1647",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ebd3-75ff-9f25-abdb05505d0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ebd3-75ff-9f25-abdb05505d0a",
        "storage_key": "property/6767906449167723/01a0244a-ebd3-75ff-9f25-abdb05505d0a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJbdQeQfbN-YgR4Bs5fELl7bE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_a876c48927eb3c3dfdeec7ae",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1501 Aviation Way, Augusta, GA 30906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-8648-75bb-a55a-28dbeb2c5809.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-8648-75bb-a55a-28dbeb2c5809",
        "storage_key": "property/6767906449167723/01a0244c-8648-75bb-a55a-28dbeb2c5809.webp",
        "width": 1280,
        "height": 889
      },
      "poi_business_url": "https://www.flyags.com/?y_source=1_MTU0Njg4MTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17534142736860957800&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-regional-airport",
      "poi_latitude": "33.3702411",
      "poi_longitude": "-81.96497450000001",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 706-798-3236",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ebd3-75ff-9f25-abdb05505d0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ebd3-75ff-9f25-abdb05505d0a",
        "storage_key": "property/6767906449167723/01a0244a-ebd3-75ff-9f25-abdb05505d0a.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJN7tiYkLP-YgRaMyXV-vJVfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "ec_4bab34a55532fad576877d03",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "3450 Wrightsboro Rd, Augusta, GA 30909, USA",
      "poi_short_description": "Mall with a typical range of shops, department stores & kiosks, plus restaurants & a food court.",
      "poi_long_description": "Mall with a typical range of shops, department stores & kiosks, plus restaurants & a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-b307-74e8-908c-8a12e37d2765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-b307-74e8-908c-8a12e37d2765",
        "storage_key": "property/6767906449167723/01a0244a-b307-74e8-908c-8a12e37d2765.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.augustamall.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13364544494855237624&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-mall",
      "poi_latitude": "33.4635485",
      "poi_longitude": "-82.0794617",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 706-550-6657",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e88f-73aa-83d4-25c4d2880a12",
        "storage_key": "property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0Ui2uy3S-YgR-K-_4GhmeLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_51f0d832d5b3bcffbf29cc28",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "3338 Wrightsboro Rd, Augusta, GA 30909, USA",
      "poi_short_description": "Chain retailer for groceries and housewares such as electronics, clothing and toys, plus auto supplies.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-8afa-70c5-b196-845590e0f793.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-8afa-70c5-b196-845590e0f793",
        "storage_key": "property/6767906449167723/01a0244c-8afa-70c5-b196-845590e0f793.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/4144-augusta-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12178921310962535574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "33.4667868",
      "poi_longitude": "-82.0701923",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 706-941-5317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e88f-73aa-83d4-25c4d2880a12",
        "storage_key": "property/6767906449167723/01a0244a-e88f-73aa-83d4-25c4d2880a12.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOZrb5TrS-YgRlkxb12c4BKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_38cf58e9eefa388fb359bbf6",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Medical College of Georgia",
      "poi_type": "Education",
      "poi_address": "1120 15th St, Augusta, GA 30912, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-8b18-710b-a49d-dbe825dfe965.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-8b18-710b-a49d-dbe825dfe965",
        "storage_key": "property/6767906449167723/01a0244c-8b18-710b-a49d-dbe825dfe965.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.augusta.edu/mcg/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9825988794448539308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medical-college-of-georgia",
      "poi_latitude": "33.4706237",
      "poi_longitude": "-81.9899149",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 706-721-3186",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJBTIb2m7M-YgRrO4SjL_sXIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "ec_df532079cac8e0438008e35d",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Charlie Norwood VA Medical Center - Uptown Division",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Freedom Way, Augusta, GA 30904, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-8dae-76ca-b0b9-be7b67422842.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-8dae-76ca-b0b9-be7b67422842",
        "storage_key": "property/6767906449167723/01a0244c-8dae-76ca-b0b9-be7b67422842.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.augusta.va.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3372177001440411258&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlie-norwood-va-medical-center---uptown-division",
      "poi_latitude": "33.464637",
      "poi_longitude": "-82.0264566",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 706-733-0188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-0eaee9826250.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-0eaee9826250",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-0eaee9826250.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkRc3k-7N-YgRev6Ywh1hzC4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_b8d805cc2ab0b73691f41823",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Georgia Cyber Innovation & Training Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Grace Hopper Ln, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-8e7e-7022-967b-52867faf6052.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-8e7e-7022-967b-52867faf6052",
        "storage_key": "property/6767906449167723/01a0244c-8e7e-7022-967b-52867faf6052.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.gacybercenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14708201154019507523&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-cyber-innovation--training-center",
      "poi_latitude": "33.4798494",
      "poi_longitude": "-81.9701351",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 706-721-0949",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ec5e-7418-9f35-baeb0327fe71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ec5e-7418-9f35-baeb0327fe71",
        "storage_key": "property/6767906449167723/01a0244a-ec5e-7418-9f35-baeb0327fe71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGYbMJBnN-YgRQ71SrgUHHsw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "ec_74efd53297375925aed54045",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Richmond Co Board of Education",
      "poi_type": "Major Employers & Offices",
      "poi_address": "864 Broad St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-8cda-7248-89f9-d6c925306ece.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-8cda-7248-89f9-d6c925306ece",
        "storage_key": "property/6767906449167723/01a0244c-8cda-7248-89f9-d6c925306ece.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rcboe.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7959091601978940662&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "richmond-co-board-of-education",
      "poi_latitude": "33.475209",
      "poi_longitude": "-81.96737480000002",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 706-826-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8a4-719d-b4ce-08d402aba8be",
        "storage_key": "property/6767906449167723/01a0244a-e8a4-719d-b4ce-08d402aba8be.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_____6vO-YgR9ty_lqRfdG4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "ec_0cf43553fed468cd08651936",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "535 Telfair St, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-de64-731b-97fa-731d22950305.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-de64-731b-97fa-731d22950305",
        "storage_key": "property/6767906449167723/01a0244a-de64-731b-97fa-731d22950305.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://augustaga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4965435687723068280&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-city-hall",
      "poi_latitude": "33.4712244",
      "poi_longitude": "-81.9618386",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 706-821-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ec5e-7418-9f35-baeb0327fe71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ec5e-7418-9f35-baeb0327fe71",
        "storage_key": "property/6767906449167723/01a0244a-ec5e-7418-9f35-baeb0327fe71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ39yK-3LM-YgReOvHMXPF6EQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "ec_8f524433ee4583f9fcbdcf83",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Judicial Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "735 James Brown Blvd, Augusta, GA 30901, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-8e75-756b-bc0f-11d741912f19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-8e75-756b-bc0f-11d741912f19",
        "storage_key": "property/6767906449167723/01a0244c-8e75-756b-bc0f-11d741912f19.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "http://augustaga.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6141757070204658065&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-judicial-center",
      "poi_latitude": "33.4696684",
      "poi_longitude": "-81.97217959999999",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 706-821-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ec5e-7418-9f35-baeb0327fe71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ec5e-7418-9f35-baeb0327fe71",
        "storage_key": "property/6767906449167723/01a0244a-ec5e-7418-9f35-baeb0327fe71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ31a8LWvM-YgRkeFK0oPnO1U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "ec_f52f0d0bfa8a0d07aa8ca8ab",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Augusta Technical College",
      "poi_type": "Education",
      "poi_address": "3200 Augusta Tech Dr, Augusta, GA 30906, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-bce0-76eb-bcb6-f81e087e0f94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244a-bce0-76eb-bcb6-f81e087e0f94",
        "storage_key": "property/6767906449167723/01a0244a-bce0-76eb-bcb6-f81e087e0f94.webp",
        "width": 846,
        "height": 561
      },
      "poi_business_url": "http://www.augustatech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18294699706374563267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "augusta-technical-college",
      "poi_latitude": "33.4177363",
      "poi_longitude": "-82.05105139999999",
      "poi_miles_from_property": "6.7 mi",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 706-771-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-e8b3-72a8-a821-683a68c6718d",
        "storage_key": "property/6767906449167723/01a0244a-e8b3-72a8-a821-683a68c6718d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJpQbcbMPR-YgRwyXmFnTU4_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_2140c0e6121b57bc324b0fea",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "poi_name": "Darling Hall Welcome Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Building 33720, 307 Chamberlain Ave Rm 172, Fort Gordon, GA 30905, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244c-9385-73b5-9c1e-18cc70bfd236.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0244c-9385-73b5-9c1e-18cc70bfd236",
        "storage_key": "property/6767906449167723/01a0244c-9385-73b5-9c1e-18cc70bfd236.webp",
        "width": 1280,
        "height": 914
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=85102469111881966&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "darling-hall-welcome-center",
      "poi_latitude": "33.4242459",
      "poi_longitude": "-82.13624659999999",
      "poi_miles_from_property": "11.5 mi",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 706-791-1922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167723/01a0244a-ec5e-7418-9f35-baeb0327fe71.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0244a-ec5e-7418-9f35-baeb0327fe71",
        "storage_key": "property/6767906449167723/01a0244a-ec5e-7418-9f35-baeb0327fe71.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHW0s2M_W-YgR7iDsqD5YLgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a2465d66dec7dcb95c5c2176",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f271f51d8f6401303ae4ce00",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_46ecb56fcac3695ded442304",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4547862d1fc516ae2e100ad1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_441e6dad04ba09784958f80a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_f201e87b4f2b6263d421c34d",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "rating": "5",
      "name": "Briana",
      "text": "I’m honestly so glad I chose this community. The location is super convenient, and while there is a train nearby, it’s something you quickly get used to …it’s never been disruptive to my daily life or sleep.\n\nThe apartments themselves are modern, clean, and well-designed. The amenities are a huge plus, and what stands out even more is how well they’re maintained. Anytime I’ve had a question or needed something looked at, it’s been handled quickly and professionally.\n\nI also want to highlight Sarah and Stephanie in the leasing office! They are AMAZING. Both are incredibly kind, professional, and genuinely care about the residents. They go out of their way to make sure everything runs smoothly and that you feel heard and taken care of. It really makes a difference having management like that. Not to mention they plan the BEST events for the residents.\n\nAny issues with pests (mainly wasps) are taken care of almost immediately and the property is kept very clean. The community feels safe, and the environment is welcoming and peaceful.\n\nOverall, this has been a great place to live. If you’re looking for a well-kept, professionally managed, and comfortable community, I highly recommend it!",
      "date": "2026-04-10",
      "title": "false"
    },
    {
      "id": "ec_6fba46592d30612488f9bcba",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "rating": "5",
      "name": "Augusta Sheds",
      "text": "Lived here for 2 years so far and love it. The view of the pool , pool itself, and quality of the property is better than anything i looked at in the area. Its also the first apartment community ive ever lived where the staff (Sarah especially) has always gone above and beyond to help me even if its not something thats necessarily their job. I love it here and im staying for the foreseeable future!",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "ec_5e14f47d02de5e0dc319b739",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "rating": "5",
      "name": "Avery Carmack",
      "text": "I’ve lived here for years and cannot say enough good things about the building and extremely kind office staff! My spouse and I love the location in proximity to downtown and how secure the complex is. No place is perfect, but we believe Millhouse is the best option in the Augusta metro for pricing, location, and amenities.",
      "date": "2025-02-13",
      "title": "false"
    },
    {
      "id": "ec_dde4ac0965957e8a0e35e5b1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "rating": "5",
      "name": "Marshall Leonard",
      "text": "This has been the best place that I have ever lived.  I have lived in apartments from NC-WV-FL and San Diego, and this has been my favorite location.  The property manager is a beautiful person, inside and out. She is very helpful and pleasant to chat with.",
      "date": "2025-02-21",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "lead_collectors": [],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "luxury-apartments-in-unit-laundry-augusta-ga",
      "search_query": "luxury apartments with in-unit laundry augusta ga",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover luxury living in Augusta, GA, with in-unit laundry amenities. Coral Grove on Grand offers stacked washer/dryer in every apartment.",
      "page_copy": "If you're searching for luxury apartments with in-unit laundry in Augusta, GA, look no further than Coral Grove on Grand. Situated in the vibrant Downtown Augusta neighborhood, our community offers an upscale living experience with stacked washer/dryers in every residence. This convenient feature reflects our commitment to providing residents with the ultimate in ease and comfort.\n\nBeyond in-unit laundry, residents can enjoy first-class amenities like a Cross-Fit inspired fitness center, a stunning waterfront off-leash bark park, and stylish outdoor lounge areas. Every detail of Coral Grove on Grand has been thoughtfully designed to embody luxury, from our gourmet-style kitchens to the elegant glass tiled backsplash. Discover the unmatched blend of convenience and luxury living in Augusta, GA, at Coral Grove on Grand.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments & In-Unit Laundry in Augusta, GA",
      "seo_description": "Explore luxury living at Coral Grove on Grand, Augusta, GA. Enjoy in-unit laundry, premium amenities, and a prime Downtown location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-dog-park-downtown-augusta",
      "search_query": "pet-friendly apartments with dog park downtown augusta",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments with Dog Park",
      "h2_subtitle": "Explore pet-friendly living in Downtown Augusta with an exclusive dog park. Coral Grove on Grand caters to you and your furry friends.",
      "page_copy": "Experience the perfect pet-friendly lifestyle at Coral Grove on Grand, located in the heart of Downtown Augusta. Our luxury apartments not only accommodate your style but also cater to your pet's needs with a fantastic waterfront off-leash dog park. This dedicated space provides a great opportunity for your furry companions to roam freely and enjoy outdoor activities.\n\nAt Coral Grove on Grand, the amenities go far beyond just the dog park. Residents can indulge in modern comforts like a Cross-Fit inspired fitness center, outdoor lounge areas, and a gourmet-style kitchen in each apartment. These features, combined with our commitment to providing a friendly environment for pets and their owners, make Coral Grove on Grand a top choice among pet-friendly apartments in Downtown Augusta.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments & Dog Park in Downtown Augusta",
      "seo_description": "Discover Coral Grove on Grand in Downtown Augusta, offering pet-friendly apartments with a fantastic on-site dog park and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-richmond-county",
      "search_query": "resort-style pool apartments richmond county",
      "category": "Amenity",
      "h1_title": "Resort-Style Pool Apartments Available",
      "h2_subtitle": "Discover resort-style pool living in Richmond County at Coral Grove on Grand. Enjoy premium amenities that redefine apartment comfort and luxury.",
      "page_copy": "Indulge in a lifestyle of leisure and elegance at Coral Grove on Grand, featuring resort-style pool apartments in Richmond County. Our community offers an ambiance reminiscent of a high-end resort, where residents can unwind and enjoy a refreshing swim or relax poolside in one of the beautifully designed outdoor lounge areas.\n\nLocated in vibrant Downtown Augusta, these apartments provide an impressive selection of amenities. Enjoy the convenience of a Cross-Fit inspired fitness center, fully equipped gourmet-style kitchens, and chic details like a glass tiled backsplash. Whether you're basking beside the pool or working out in our advanced fitness center, Coral Grove on Grand promises an unparalleled living experience in Richmond County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort-Style Pool Apartments in Richmond County",
      "seo_description": "Experience luxury living with a resort-style pool in Richmond County at Coral Grove on Grand. Enjoy premium amenities in a prime Augusta location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "electric-car-charging-apartments-augusta-ga",
      "search_query": "electric car charging apartments augusta ga",
      "category": "Amenity",
      "h1_title": "Electric Car Charging Apartments Augusta",
      "h2_subtitle": "Live sustainably at Coral Grove on Grand in Augusta, GA, with convenient electric car charging stations. A modern home for eco-conscious residents.",
      "page_copy": "Coral Grove on Grand offers the ideal setting for eco-conscious residents with electric car charging apartments in Augusta, GA. Our cutting-edge community supports sustainable living by providing on-site electric vehicle charging stations, ensuring that residents can easily power up their vehicles while enjoying all the comforts of home.\n\nLocated in the dynamic Downtown Augusta area, Coral Grove on Grand delivers a blend of sophistication and sustainability. Along with the convenience of EV charging, residents can enjoy a host of amenities, including a Cross-Fit inspired fitness center, outdoor lounge spaces, and a water front off-leash bark park. Every apartment features elegant designs, such as gourmet-style kitchens and glass tiled backsplashes, making Coral Grove on Grand a desirable destination for those looking to minimize their carbon footprint without sacrificing lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Electric Car Charging Apartments in Augusta, GA",
      "seo_description": "Coral Grove on Grand in Augusta, GA offers electric car charging facilities, luxurious amenities, and a prime Downtown location for modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "apartments-quartz-countertops-downtown-augusta",
      "search_query": "apartments with quartz countertops downtown augusta",
      "category": "Amenity",
      "h1_title": "Apartments with Quartz Countertops in Augusta",
      "h2_subtitle": "Find stunning apartments with quartz countertops at Coral Grove on Grand in Downtown Augusta. Elevate your living experience with superior finishes.",
      "page_copy": "At Coral Grove on Grand in Downtown Augusta, experience the elegance of apartments with exquisite quartz countertops. These premium surfaces not only add luxury but also offer durability and style, perfectly complementing the modern aesthetic of your home.\n\nLocated in the lively heart of Downtown Augusta, Coral Grove on Grand presents more than just beautiful interiors. Residents enjoy access to a broad array of amenities, including a Cross-Fit inspired fitness center, a water front off-leash dog park, and outdoor lounge areas. The gourmet-style kitchens, beautifully accentuated by glass tiled backsplashes and quartz countertops, provide a sophisticated and functional space perfect for both entertaining and everyday living, making this the ideal choice for discerning residents.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Quartz Countertops in Downtown Augusta",
      "seo_description": "Discover luxury living at Coral Grove on Grand with quartz countertops and superior amenities in Downtown Augusta.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-downtown-augusta",
      "search_query": "one bedroom apartments downtown augusta",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Downtown Augusta",
      "h2_subtitle": "Explore stylish one bedroom apartments at Coral Grove on Grand, located in vibrant Downtown Augusta. Experience top-notch amenities and urban comfort.",
      "page_copy": "Discover the perfect urban retreat with one bedroom apartments at Coral Grove on Grand in Downtown Augusta. These thoughtfully designed spaces provide the perfect blend of style and comfort, featuring chic details such as glass tiled backsplashes and in-home stacked washer/dryers.\n\nSituated in the bustling Downtown Augusta area, Coral Grove on Grand offers residents more than just a place to live. Enjoy a range of amenities including a Cross-Fit inspired fitness center, outdoor lounge areas, and a water front off-leash bark park. Our one bedroom apartments offer a sophisticated living environment, ideal for those looking to enjoy the best of city life in a tranquil, modern setting.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Downtown Augusta",
      "seo_description": "Coral Grove on Grand offers stylish one bedroom apartments with top amenities in Downtown Augusta. Discover urban living at its finest.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-richmond-county",
      "search_query": "two bedroom apartments richmond county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Richmond County",
      "h2_subtitle": "Discover spacious two bedroom apartments at Coral Grove on Grand, nestled in Richmond County. Enjoy a prime location and modern amenities.",
      "page_copy": "Embrace a comfortable lifestyle with the two bedroom apartments at Coral Grove on Grand, located in the heart of Richmond County, Augusta. These spacious homes are designed with your needs in mind, featuring luxurious finishes and modern conveniences like in-home stacked washer/dryers and gourmet-style kitchens complete with glass tiled backsplashes.\n\nSet within the vibrant community of Richmond County, Coral Grove on Grand offers more than just apartment living. Residents have access to a host of exceptional amenities including an indoor tire-flip station at our Cross-Fit inspired fitness center, outdoor lounge areas, and a water front off-leash bark park. Our two bedroom residences provide the perfect setting for anyone seeking a blend of space, style, and suburban comfort.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Richmond County",
      "seo_description": "Find spacious two bedroom apartments with luxury amenities at Coral Grove on Grand in Richmond County, offering a prime location and modern conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "apartments-near-augusta-university-downtown",
      "search_query": "apartments near augusta university downtown augusta",
      "category": "School",
      "h1_title": "Apartments Near Augusta University",
      "h2_subtitle": "Live close to Augusta University at Coral Grove on Grand. Located in Downtown Augusta, our apartments offer both convenience and comfort.",
      "page_copy": "Situated just a stone's throw away from Augusta University, Coral Grove on Grand provides an ideal living option for students and staff alike. Nestled in the heart of Downtown Augusta, our apartments combine proximity with superior living standards, featuring modern amenities and stylish interiors such as glass tiled backsplashes and stacked washer/dryers.\n\nCoral Grove on Grand offers a perfect blend of convenience and lifestyle. Enjoy being close to campus while taking advantage of our expansive range of amenities, which include a Cross-Fit inspired fitness center, outdoor lounge spaces, and even a water front off-leash bark park. With the city at your doorstep, you can enjoy seamless access to both academic pursuits and vibrant city life.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Augusta University in Downtown",
      "seo_description": "Find convenient living at Coral Grove on Grand, just minutes from Augusta University in Downtown Augusta, with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "apartments-close-to-augusta-university-summerville",
      "search_query": "apartments close to augusta university summerville campus",
      "category": "School",
      "h1_title": "Apartments Near Augusta University Summerville",
      "h2_subtitle": "Explore Coral Grove on Grand, offering apartments close to Augusta University Summerville Campus. Experience unmatched convenience and modern amenities.",
      "page_copy": "Coral Grove on Grand provides the ideal location for those seeking apartments near Augusta University Summerville Campus. Nestled in a strategic position, our community allows students, faculty, and staff unparalleled access to the campus, coupled with the comforts of modern living such as in-home stacked washer/dryers and sleek glass tiled backsplashes.\n\nBeyond the proximity, Coral Grove on Grand boasts an array of amenities that make life more enjoyable. Residents can keep fit with our Cross-Fit inspired fitness center or relax in the outdoor lounge areas. For pet owners, the water front off-leash bark park provides the perfect spot for some furry fun. Live moments away from campus while enjoying all that our community has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Augusta University Summerville",
      "seo_description": "Discover apartments at Coral Grove on Grand near Augusta University's Summerville Campus, offering modern amenities and prime access to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "apartments-near-augusta-technical-college",
      "search_query": "apartments near augusta technical college richmond county",
      "category": "School",
      "h1_title": "Apartments Near Augusta Technical College",
      "h2_subtitle": "Live conveniently at Coral Grove on Grand, with easy access to Augusta Technical College in Richmond County. Discover modern living and amenities.",
      "page_copy": "Coral Grove on Grand, located in Richmond County, offers the perfect setting for individuals searching for apartments near Augusta Technical College. Our community combines easy access to the college with the comfort of luxurious living spaces, including modern kitchens with glass tiled backsplashes and the convenience of in-home stacked washer/dryers.\n\nIn addition to its proximity to Augusta Technical College, Coral Grove on Grand features a variety of amenities that enhance everyday life. From a Cross-Fit inspired fitness center to outdoor lounge areas and a water front off-leash bark park, our community caters to diverse lifestyles. Enjoy a seamless blend of educational pursuits and residential comfort at Coral Grove on Grand.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Augusta Technical College",
      "seo_description": "Find apartments at Coral Grove on Grand near Augusta Technical College in Richmond County, offering modern amenities and easy access to education.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "apartments-near-augusta-university-university-hall",
      "search_query": "apartments near augusta university university hall ga",
      "category": "School",
      "h1_title": "Apartments Near University Hall, Augusta",
      "h2_subtitle": "Coral Grove on Grand offers apartments near Augusta University, specifically close to University Hall. Enjoy both convenience and comfort in GA.",
      "page_copy": "For those seeking convenient living arrangements, Coral Grove on Grand presents an attractive option with its close proximity to University Hall at Augusta University. Tucked within Downtown Augusta, our community integrates a strategic location with premium living facilities including gourmet-style kitchens featuring glass tiled backsplashes and the convenience of in-home stacked washer/dryers.\n\nCoral Grove on Grand is designed to enhance your lifestyle while keeping you close to campus. Enjoy the benefits of our Cross-Fit inspired fitness center, relax in our outdoor lounge areas, or take your pet to our water front off-leash bark park. The ease of being near University Hall allows residents to balance academic commitments with a vibrant and comfortable home environment.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University Hall, Augusta University",
      "seo_description": "Explore Coral Grove on Grand, offering proximity to University Hall at Augusta University in GA, with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "apartments-near-piedmont-augusta-downtown",
      "search_query": "apartments near piedmont augusta downtown",
      "category": "Hospital",
      "h1_title": "Apartments Near Piedmont Augusta Downtown",
      "h2_subtitle": "Discover Coral Grove on Grand, perfectly situated near Piedmont Augusta in downtown. Experience effortless living with modern amenities.",
      "page_copy": "Coral Grove on Grand is ideally located for anyone seeking apartments near Piedmont Augusta Downtown. Our community seamlessly integrates convenience with comfort, providing a fantastic base for healthcare professionals and visitors to the hospital. Residents enjoy modern features such as stacked washer/dryers and gourmet-style kitchens with glass tiled backsplashes in each home.\n\nIn addition to proximity to Piedmont Augusta, Coral Grove on Grand offers an array of community amenities to enrich your living experience. Take advantage of our Cross-Fit inspired fitness center, relax in our carefully designed outdoor lounge areas, or let your furry friend roam freely in our water front off-leash bark park. With such conveniences, living at Coral Grove on Grand offers more than just an apartment near your workplace; it offers a lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piedmont Augusta Downtown",
      "seo_description": "Live at Coral Grove on Grand, near Piedmont Augusta Downtown, offering modern amenities in an ideal location for convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "apartments-near-riverwalk-augusta-downtown",
      "search_query": "apartments near Riverwalk Augusta Downtown",
      "category": "Park",
      "h1_title": "Apartments Near Riverwalk Augusta",
      "h2_subtitle": "Enjoy life at Coral Grove on Grand, closely situated near the beautiful Riverwalk in Downtown Augusta. Discover vibrant city living today.",
      "page_copy": "For those seeking apartments near Riverwalk Augusta, Coral Grove on Grand offers a prime location with exceptional amenities. Nestled in Downtown Augusta, our community provides easy access to the scenic Riverwalk, ideal for leisurely strolls or invigorating runs along the water. Each apartment features modern conveniences like glass tiled backsplashes in the kitchen and in-home stacked washer/dryers, making everyday living a breeze.\n\nBeyond its great location near Riverwalk Augusta, Coral Grove on Grand offers residents a premier living experience with our Cross-Fit inspired fitness center and inviting outdoor lounge areas. Pet lovers will appreciate the water front off-leash bark park where dogs can play freely. Choosing Coral Grove on Grand means embracing a lifestyle defined by comfort, convenience, and proximity to one of Augusta's most celebrated attractions—the Riverwalk.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Riverwalk Augusta",
      "seo_description": "Find your home at Coral Grove on Grand, close to Riverwalk Augusta Downtown, offering vibrant living with modern amenities and beautiful scenery.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "apartment-living-close-to-phinizy-swamp-nature-park",
      "search_query": "apartment living close to Phinizy Swamp Nature Park 30901",
      "category": "Park",
      "h1_title": "Apartment Living Near Phinizy Swamp",
      "h2_subtitle": "Experience nature and comfort at Coral Grove on Grand, located close to Phinizy Swamp Nature Park. Embrace serene living in the heart of Augusta.",
      "page_copy": "Coral Grove on Grand is your gateway to both urban convenience and nature’s beauty, offering apartment living close to Phinizy Swamp Nature Park. Situated in Downtown Augusta, our community provides easy access to the park, known for its rich biodiversity and picturesque hiking trails. It’s the perfect spot for nature lovers wanting a peaceful retreat after a busy day.\n\nBesides its proximity to Phinizy Swamp Nature Park, Coral Grove on Grand offers residents top-tier amenities such as an expansive Cross-Fit inspired fitness center and beautifully designed outdoor lounge areas. Each apartment is equipped with modern features like gourmet-style kitchens and in-home stacked washer/dryers. Your pets can also enjoy our exclusive water front off-leash bark park. Make Coral Grove on Grand your home and enjoy the best of urban and natural living.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Living Near Phinizy Swamp",
      "seo_description": "Live at Coral Grove on Grand and enjoy apartment living close to Phinizy Swamp Nature Park in 30901, with modern comforts and natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5760613594693632",
      "property_id": "6767906449167723",
      "source": "generator",
      "page_item_url": "coral-grove-apartments-by-aqueduct-park",
      "search_query": "Coral Grove apartments by Aqueduct Park Richmond County",
      "category": "Park",
      "h1_title": "Coral Grove by Aqueduct Park",
      "h2_subtitle": "Discover Coral Grove on Grand, an ideal choice near Aqueduct Park. Enjoy modern amenities in Richmond County's dynamic neighborhood.",
      "page_copy": "Nestled in Richmond County, Coral Grove on Grand offers an unparalleled living experience with its proximity to Aqueduct Park. If you're searching for Coral Grove apartments by Aqueduct Park, you'll find that our community provides the perfect blend of city life and serene park proximity, making it a prime choice for those who love outdoor exploration.\n\nOur residents enjoy various amenities including a state-of-the-art Cross-Fit inspired fitness center and chic outdoor lounge areas, ensuring a lifestyle of both convenience and relaxation. Each apartment at Coral Grove boasts a gourmet-style kitchen equipped with glass tiled backsplashes and in-home stacked washer/dryers for your convenience. Plus, our water front off-leash bark park offers a haven for pet owners. Choose Coral Grove on Grand and experience exceptional living near Aqueduct Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Coral Grove by Aqueduct Park",
      "seo_description": "Live at Coral Grove, located close to Aqueduct Park in Richmond County, offering a perfect blend of convenience and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImlOdE1TVEtiOHg5THdpMHlsaGFmR3c9PSIsInZhbHVlIjoiKzlCUzdpSFM5OHZzTDliRzVpZE9GUT09IiwibWFjIjoiODUxYTc2Y2UyNDVhZDI1NmZmMzhmZjc4NDA0ODQ4NGI0YWQ0ZjVhNzIzOWU2YmQwNjUwYmEwZmJhY2FhMjc5NCJ9"
    }
  ],
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImlOdE1TVEtiOHg5THdpMHlsaGFmR3c9PSIsInZhbHVlIjoiKzlCUzdpSFM5OHZzTDliRzVpZE9GUT09IiwibWFjIjoiODUxYTc2Y2UyNDVhZDI1NmZmMzhmZjc4NDA0ODQ4NGI0YWQ0ZjVhNzIzOWU2YmQwNjUwYmEwZmJhY2FhMjc5NCJ9",
  "custom_audioeye_site_id": "b27a05da-1256-4bf4-aae4-58ec74f389ce",
  "custom_audioeye_site_hash": "704f4ac7ba2f231415ab3d67063f9fcc"
};

export const generatedAt = '2026-08-25T15:40:20.097Z';
